import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../api';
import NotaAvulsaModal from '../components/NotaAvulsaModal';
import ImportarNotasModal from '../components/ImportarNotasModal';
import EnviarEmailsNotasModal from '../components/EnviarEmailsNotasModal';
import CteModal from '../components/CteModal';

const cores = {
  navy: '#1A2233', navyD: '#253047', navyL: 'rgba(26,34,51,0.08)',
  gold: '#e8a020', green: '#27ae60', red: '#e74c3c',
  border: '#d4dde8', muted: '#6b7a8d', orange: '#D85A30',
  bg: '#f7f8fa', card: '#ffffff'
};

const MESES = [
  { value: '', label: 'Todos os meses' },
  { value: '01', label: 'Janeiro' }, { value: '02', label: 'Fevereiro' },
  { value: '03', label: 'Março' },   { value: '04', label: 'Abril' },
  { value: '05', label: 'Maio' },    { value: '06', label: 'Junho' },
  { value: '07', label: 'Julho' },   { value: '08', label: 'Agosto' },
  { value: '09', label: 'Setembro' },{ value: '10', label: 'Outubro' },
  { value: '11', label: 'Novembro' },{ value: '12', label: 'Dezembro' },
];

function StatusBadge({ status }) {
  const map = {
    pendente:  { bg: '#fff3cd', color: '#856404', label: 'Pendente' },
    pago:      { bg: '#d1f5e0', color: '#155724', label: 'Pago' },
    reprovado: { bg: '#fde8e8', color: '#991b1b', label: 'Reprovado' },
  };
  const s = map[status] || map.pendente;
  return <span style={{ background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>● {s.label}</span>;
}

function Card({ children, style }) {
  return (
    <div style={{ background: cores.card, borderRadius: 14, padding: 20, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', marginBottom: 16, ...style }}>
      {children}
    </div>
  );
}

const fmt = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const inputStyle = { width: '100%', padding: '9px 12px', border: `1.5px solid ${cores.border}`, borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };
const btnPrimary = { padding: '9px 18px', background: cores.orange, color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer' };
const btnGhost = { padding: '9px 18px', background: '#f0f3f7', color: cores.muted, border: `1px solid ${cores.border}`, borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: 'pointer' };

const iconeMap = { bus: '🚌', car: '🚗', moto: '🏍️', food: '🍽️', box: '📦', other: '📎', parking: '🅿️', plane: '✈️', hotel: '🏨', fuel: '⛽' };
const iconeEmoji = (chave) => iconeMap[chave] || chave || '';

// ── ABA REEMBOLSO ─────────────────────────────────────────────────────────────
function AbaReembolso({ toast }) {
  const [lancamentos, setLancamentos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtroFunc, setFiltroFunc] = useState('all');
  const [filtroMes, setFiltroMes] = useState('');
  const [filtroAno, setFiltroAno] = useState(new Date().getFullYear().toString());
  const [periodoInicio, setPeriodoInicio] = useState('');
  const [periodoFim, setPeriodoFim] = useState('');

  // Modal de novo lançamento (pelo gestor)
  const [showModal, setShowModal] = useState(false);
  const [novoLanc, setNovoLanc] = useState({ usuario_id: '', data: '', categoria: '', valor: '', descricao: '' });
  const [salvando, setSalvando] = useState(false);

  // Modal de edição de lançamento
  const [editandoLanc, setEditandoLanc] = useState(null); // objeto do lanc sendo editado
  const [salvandoEdicao, setSalvandoEdicao] = useState(false);

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    try {
      const [lanc, usrs, cats] = await Promise.all([
        api.get('/lancamentos'),
        api.get('/usuarios'),
        api.get('/configuracoes/categorias').catch(() => ({ data: [] })),
      ]);
      setLancamentos(lanc.data);
      setUsuarios(usrs.data); // todos os usuarios do tenant
      setCategorias(cats.data);
    } catch {}
  };

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/lancamentos/${id}/status`, { status });
      toast(status === 'pago' ? 'Marcado como pago!' : 'Reprovado!', status === 'pago' ? 'success' : 'error');
      carregar();
    } catch { toast('Erro ao atualizar', 'error'); }
  };

  const pagarTodos = async (usuario_id) => {
    try {
      await api.patch(`/lancamentos/pagar/${usuario_id}`);
      toast('Pagamentos confirmados!', 'success');
      carregar();
    } catch { toast('Erro ao pagar', 'error'); }
  };

  const salvarNovoLanc = async () => {
    if (!novoLanc.usuario_id || !novoLanc.data || !novoLanc.categoria || !novoLanc.valor) {
      toast('Preencha todos os campos obrigatórios.', 'error');
      return;
    }
    setSalvando(true);
    try {
      await api.post('/lancamentos', {
        usuario_id: parseInt(novoLanc.usuario_id),
        data: novoLanc.data,
        categoria: novoLanc.categoria,
        valor: parseFloat(novoLanc.valor),
        descricao: novoLanc.descricao,
        status: 'pago',
      });
      toast('Reembolso adicionado!', 'success');
      setShowModal(false);
      setNovoLanc({ usuario_id: '', data: '', categoria: '', valor: '', descricao: '' });
      carregar();
    } catch { toast('Erro ao salvar reembolso.', 'error'); }
    setSalvando(false);
  };

  const salvarEdicao = async () => {
    if (!editandoLanc.data || !editandoLanc.categoria || !editandoLanc.valor) {
      toast('Preencha todos os campos obrigatórios.', 'error');
      return;
    }
    setSalvandoEdicao(true);
    try {
      await api.patch(`/lancamentos/${editandoLanc.id}`, {
        data: editandoLanc.data,
        categoria: editandoLanc.categoria,
        valor: parseFloat(editandoLanc.valor),
        descricao: editandoLanc.descricao,
      });
      toast('Reembolso atualizado!', 'success');
      setEditandoLanc(null);
      carregar();
    } catch { toast('Erro ao atualizar reembolso.', 'error'); }
    setSalvandoEdicao(false);
  };

  const excluirLanc = async () => {
    if (!window.confirm('Tem certeza que deseja excluir este reembolso?')) return;
    try {
      await api.delete(`/lancamentos/${editandoLanc.id}`);
      toast('Reembolso excluído!', 'success');
      setEditandoLanc(null);
      carregar();
    } catch { toast('Erro ao excluir reembolso.', 'error'); }
  };

  const abrirEdicao = (l) => {
    setEditandoLanc({
      id: l.id,
      data: l.data ? l.data.substring(0, 10) : '',
      categoria: l.categoria || '',
      valor: l.valor || '',
      descricao: l.descricao || '',
      usuario_nome: l.usuario_nome,
    });
  };

  const lancFiltrados = lancamentos.filter(l => {
    const data = new Date(l.data.substring(0,10) + 'T00:00:00');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = String(data.getFullYear());
    if (filtroFunc !== 'all' && l.usuario_id !== parseInt(filtroFunc)) return false;
    if (filtroMes && mes !== filtroMes) return false;
    if (filtroAno && ano !== filtroAno) return false;
    if (periodoInicio && data < new Date(periodoInicio + 'T00:00:00')) return false;
    if (periodoFim    && data > new Date(periodoFim    + 'T23:59:59')) return false;
    return true;
  });

  const total = lancFiltrados.reduce((a, b) => a + parseFloat(b.valor), 0);
  const pend  = lancFiltrados.filter(l => l.status === 'pendente').reduce((a, b) => a + parseFloat(b.valor), 0);
  const pago  = lancFiltrados.filter(l => l.status === 'pago').reduce((a, b) => a + parseFloat(b.valor), 0);
  const anos  = [...new Set(lancamentos.map(l => new Date(l.data.substring(0,10) + 'T00:00:00').getFullYear()))].sort((a, b) => b - a);
  if (!anos.includes(new Date().getFullYear())) anos.unshift(new Date().getFullYear());

  const selectStyle = { padding: '8px 10px', border: `1.5px solid ${cores.border}`, borderRadius: 8, fontSize: 13, background: 'white', cursor: 'pointer', width: '100%' };

  // ── Exportar Excel (CSV) ──
  const exportarExcel = () => {
    const periodoLabel = periodoInicio || periodoFim
      ? `${periodoInicio || '?'}_a_${periodoFim || '?'}`
      : filtroMes
        ? `${MESES.find(m => m.value === filtroMes)?.label}_${filtroAno}`
        : filtroAno || 'Todos';

    const linhas = [
      ['Funcionário', 'Data', 'Categoria', 'Descrição', 'Valor', 'Status'],
      ...lancFiltrados.map(l => [
        l.usuario_nome,
        new Date(l.data.substring(0,10) + 'T00:00:00').toLocaleDateString('pt-BR'),
        l.categoria,
        l.descricao || '',
        Number(l.valor).toFixed(2).replace('.', ','),
        l.status,
      ]),
      [],
      ['', '', '', 'TOTAL', fmt(total), ''],
      ['', '', '', 'A PAGAR', fmt(pend), ''],
      ['', '', '', 'PAGO', fmt(pago), ''],
    ];

    const csv = linhas.map(r => r.join(';')).join('\n');
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Reembolsos_${periodoLabel}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    toast('Excel exportado!', 'success');
  };

  // ── Exportar PDF ──
  const exportarPDF = () => {
    const periodoLabel = periodoInicio || periodoFim
      ? `${periodoInicio ? new Date(periodoInicio+'T12:00:00').toLocaleDateString('pt-BR') : '?'} até ${periodoFim ? new Date(periodoFim+'T12:00:00').toLocaleDateString('pt-BR') : '?'}`
      : filtroMes
        ? `${MESES.find(m => m.value === filtroMes)?.label} ${filtroAno}`
        : filtroAno || 'Todos os períodos';

    const win = window.open('', '_blank');
    const porFunc = usuarios.map(u => {
      const ul = lancFiltrados.filter(l => l.usuario_id === u.id);
      if (!ul.length) return '';
      const tot = ul.reduce((a, b) => a + parseFloat(b.valor), 0);
      const rows = ul.map(l => `
        <tr>
          <td>${new Date(l.data.substring(0,10) + 'T00:00:00').toLocaleDateString('pt-BR')}</td>
          <td>${l.categoria}</td>
          <td>${l.descricao || '—'}</td>
          <td style="text-align:right">${fmt(l.valor)}</td>
          <td style="text-align:center">${l.status === 'pago' ? '✅ Pago' : l.status === 'pendente' ? '⏳ Pendente' : '❌ Reprovado'}</td>
        </tr>`).join('');
      return `
        <div class="func-block">
          <div class="func-header">
            <span class="avatar">${u.iniciais}</span>
            <strong>${u.nome}</strong>
            <span class="func-total">${fmt(tot)}</span>
          </div>
          <table>
            <thead><tr><th>Data</th><th>Categoria</th><th>Descrição</th><th>Valor</th><th>Status</th></tr></thead>
            <tbody>${rows}</tbody>
          </table>
        </div>`;
    }).join('');

    win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
      <title>Reembolsos — ${periodoLabel}</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 32px; color: #1a2233; font-size: 13px; }
        h1 { color: #D85A30; font-size: 20px; margin-bottom: 4px; }
        .sub { color: #6b7a8d; font-size: 12px; margin-bottom: 24px; }
        .totais { display: flex; gap: 20px; margin-bottom: 28px; }
        .totais div { background: #f7f8fa; border-radius: 10px; padding: 12px 20px; flex: 1; }
        .totais .label { font-size: 10px; font-weight: 700; color: #6b7a8d; text-transform: uppercase; }
        .totais .val { font-size: 18px; font-weight: 800; margin-top: 2px; }
        .func-block { margin-bottom: 28px; }
        .func-header { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; background: #fff8f0; padding: 10px 14px; border-radius: 8px; }
        .avatar { background: #D85A30; color: white; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 12px; text-align: center; line-height: 32px; }
        .func-total { margin-left: auto; font-weight: 800; color: #D85A30; font-size: 15px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #f0f3f7; text-align: left; padding: 7px 10px; font-size: 11px; color: #6b7a8d; text-transform: uppercase; }
        td { padding: 7px 10px; border-bottom: 1px solid #e4e9f0; font-size: 12px; }
        .footer { margin-top: 32px; padding-top: 12px; border-top: 2px solid #e4e9f0; display: flex; justify-content: space-between; color: #6b7a8d; font-size: 11px; }
        @media print { body { padding: 16px; } }
      </style></head><body>
      <h1>🔄 Reembolsos</h1>
      <div class="sub">Período: ${periodoLabel} · Gerado em ${new Date().toLocaleDateString('pt-BR')}</div>
      <div class="totais">
        <div><div class="label">Total</div><div class="val" style="color:#1A2233">${fmt(total)}</div></div>
        <div><div class="label">A Pagar</div><div class="val" style="color:#e8a020">${fmt(pend)}</div></div>
        <div><div class="label">Pago</div><div class="val" style="color:#27ae60">${fmt(pago)}</div></div>
      </div>
      ${porFunc}
      <div class="footer"><span>Sobraa — Relatório de Reembolsos</span><span>${periodoLabel}</span></div>
      </body></html>`);
    win.document.close();
    setTimeout(() => win.print(), 500);
  };

  return (
    <div>
      {/* Filtros + botões de ação */}
      <Card>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#1a2233', marginBottom: 10 }}>Filtrar por:</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
          <select value={filtroMes} onChange={e => setFiltroMes(e.target.value)} style={selectStyle}>
            {MESES.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
          <select value={filtroAno} onChange={e => setFiltroAno(e.target.value)} style={selectStyle}>
            <option value="">Todos os anos</option>
            {anos.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        {/* Filtro de período */}
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#1a2233', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
            Filtrar por período:
            {(periodoInicio || periodoFim) && (
              <button onClick={() => { setPeriodoInicio(''); setPeriodoFim(''); }}
                style={{ background: 'none', border: 'none', color: cores.orange, cursor: 'pointer', fontSize: 12, fontWeight: 600, padding: 0, textDecoration: 'underline' }}>
                limpar
              </button>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', background: 'white', border: `1px solid ${periodoInicio || periodoFim ? cores.orange : cores.border}`, borderRadius: 8, overflow: 'hidden', transition: 'border-color .2s' }}>
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, padding: '0 12px' }}>
              <span style={{ fontSize: 13, color: cores.muted, fontWeight: 600, whiteSpace: 'nowrap', marginRight: 6 }}>De</span>
              <input type="date" value={periodoInicio} max={periodoFim || undefined}
                onChange={e => setPeriodoInicio(e.target.value)}
                style={{ flex: 1, border: 'none', background: 'transparent', fontSize: 13, outline: 'none', minWidth: 0, color: '#1a2233', padding: '8px 0', cursor: 'pointer' }} />
            </div>
            <div style={{ width: 1, height: 36, background: cores.border, flexShrink: 0 }} />
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, padding: '0 12px' }}>
              <span style={{ fontSize: 13, color: cores.muted, fontWeight: 600, whiteSpace: 'nowrap', marginRight: 6 }}>Até</span>
              <input type="date" value={periodoFim} min={periodoInicio || undefined}
                onChange={e => setPeriodoFim(e.target.value)}
                style={{ flex: 1, border: 'none', background: 'transparent', fontSize: 13, outline: 'none', minWidth: 0, color: '#1a2233', padding: '8px 0', cursor: 'pointer' }} />
            </div>
          </div>
        </div>
        <select value={filtroFunc} onChange={e => setFiltroFunc(e.target.value)} style={{ ...selectStyle, marginBottom: 10 }}>
          <option value="all">Todos os funcionários</option>
          {usuarios.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
        </select>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
          <button onClick={() => { setFiltroMes(''); setFiltroAno(new Date().getFullYear().toString()); setFiltroFunc('all'); setPeriodoInicio(''); setPeriodoFim(''); }} style={{ ...btnGhost }}>
            Limpar filtros
          </button>
          <button onClick={exportarPDF} style={{ padding: '9px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
            📄 PDF
          </button>
          <button onClick={exportarExcel} style={{ padding: '9px', background: '#27ae60', color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
            📊 Excel
          </button>
        </div>
      </Card>

      {/* Cards de totais */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 }}>
        {[['Total', total, cores.navy], ['A Pagar', pend, cores.gold], ['Pago', pago, cores.green]].map(([label, val, cor]) => (
          <div key={label} style={{ background: 'white', borderRadius: 14, padding: 14, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: `4px solid ${cor}` }}>
            <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{fmt(val)}</div>
          </div>
        ))}
      </div>

      {/* Por Funcionário + botão adicionar */}
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ fontWeight: 700, fontSize: 16 }}>Por Funcionário</div>
          <button onClick={() => setShowModal(true)} style={{ ...btnPrimary, padding: '7px 14px', fontSize: 13 }}>
            + Adicionar Reembolso
          </button>
        </div>
        {(() => {
          // Agrupa lançamentos por usuário direto dos dados — nunca perde ninguém
          const porUsuario = lancFiltrados.reduce((acc, l) => {
            const key = l.usuario_id;
            if (!acc[key]) acc[key] = { id: l.usuario_id, nome: l.usuario_nome, iniciais: (l.usuario_nome || '?').split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase(), lancamentos: [] };
            acc[key].lancamentos.push(l);
            return acc;
          }, {});

          const grupos = Object.values(porUsuario);
          if (!grupos.length) return (
            <div style={{ textAlign: 'center', padding: 24, color: cores.muted }}>
              <div style={{ fontSize: 36 }}>📭</div>
              <p style={{ margin: '8px 0 0' }}>Nenhum lançamento encontrado</p>
            </div>
          );

          return grupos.map(u => {
            const ul = u.lancamentos;
            const tot = ul.reduce((a, b) => a + parseFloat(b.valor), 0);
            const pendentes = ul.filter(l => l.status === 'pendente');
            return (
              <div key={u.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: `1px solid ${cores.border}`, flexWrap: 'wrap', gap: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: cores.navyL, color: cores.navyD, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>{u.iniciais}</div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{u.nome}</div>
                    <div style={{ fontSize: 12, color: cores.muted }}>{ul.length} lanç. · {fmt(tot)}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <StatusBadge status={pendentes.length === 0 ? 'pago' : 'pendente'} />
                  {pendentes.length > 0 && (
                    <button onClick={() => pagarTodos(u.id)} style={{ padding: '5px 12px', background: cores.green, color: 'white', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>Pagar Tudo</button>
                  )}
                </div>
              </div>
            );
          });
        })()}
      </Card>

      {/* Detalhes */}
      <Card>
        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 16 }}>Detalhes</div>
        {lancFiltrados.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 32, color: cores.muted }}>
            <div style={{ fontSize: 40 }}>📭</div>
            <p>Nenhum lançamento encontrado</p>
          </div>
        ) : lancFiltrados.map(l => (
          <div key={l.id} style={{ padding: '12px 0', borderBottom: `1px solid ${cores.border}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{l.usuario_nome}</div>
                <div style={{ fontSize: 12, color: cores.muted }}>{new Date(l.data.substring(0,10) + 'T00:00:00').toLocaleDateString('pt-BR')} · {l.categoria}</div>
                {l.descricao && <div style={{ fontSize: 12, color: cores.muted, marginTop: 2 }}>{l.descricao}</div>}
              </div>
              <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                <div style={{ fontWeight: 700, fontSize: 15 }}>{fmt(l.valor)}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <StatusBadge status={l.status} />
                  <button onClick={() => abrirEdicao(l)}
                    style={{ padding: '3px 9px', background: '#eef2ff', color: '#2563eb', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>✏️</button>
                </div>
              </div>
            </div>
            {l.status === 'pendente' && (
              <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                <button onClick={() => setStatus(l.id, 'pago')} style={{ flex: 1, padding: '8px', background: cores.green, color: 'white', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>✅ Pagar</button>
                <button onClick={() => setStatus(l.id, 'reprovado')} style={{ flex: 1, padding: '8px', background: cores.red, color: 'white', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>❌ Pendente</button>
              </div>
            )}
          </div>
        ))}
      </Card>

      {/* ── Modal: Adicionar Reembolso ── */}
      {showModal && (
        <div onClick={e => e.target === e.currentTarget && setShowModal(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: '100%', maxWidth: 460, boxShadow: '0 24px 64px rgba(0,0,0,0.2)' }}>
            <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 20, color: '#1a2233' }}>➕ Adicionar Reembolso</div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>FUNCIONÁRIO *</label>
              <select value={novoLanc.usuario_id} onChange={e => setNovoLanc(p => ({ ...p, usuario_id: e.target.value }))} style={inputStyle}>
                <option value="">— Selecionar —</option>
                {usuarios.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
              </select>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>DATA *</label>
                <input type="date" value={novoLanc.data} onChange={e => setNovoLanc(p => ({ ...p, data: e.target.value }))} style={inputStyle} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>VALOR (R$) *</label>
                <input type="number" step="0.01" placeholder="0,00" value={novoLanc.valor} onChange={e => setNovoLanc(p => ({ ...p, valor: e.target.value }))} style={inputStyle} />
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>CATEGORIA *</label>
              {categorias.length > 0 ? (
                <select value={novoLanc.categoria} onChange={e => setNovoLanc(p => ({ ...p, categoria: e.target.value }))} style={inputStyle}>
                  <option value="">— Selecionar —</option>
                  {categorias.map(c => <option key={c.id} value={c.nome}>{iconeEmoji(c.icone)} {c.nome}</option>)}
                </select>
              ) : (
                <input placeholder="Ex: Alimentação" value={novoLanc.categoria} onChange={e => setNovoLanc(p => ({ ...p, categoria: e.target.value }))} style={inputStyle} />
              )}
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>DESCRIÇÃO (opcional)</label>
              <input placeholder="Ex: Almoço com cliente" value={novoLanc.descricao} onChange={e => setNovoLanc(p => ({ ...p, descricao: e.target.value }))} style={inputStyle} />
            </div>

            <div style={{ background: '#f0fdf4', borderRadius: 8, padding: '10px 14px', marginBottom: 20, fontSize: 12, color: '#155724', fontWeight: 600 }}>
              ✅ O reembolso será registrado com status <strong>Pago</strong> automaticamente.
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModal(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={salvarNovoLanc} disabled={salvando} style={{ ...btnPrimary, flex: 2 }}>
                {salvando ? 'Salvando...' : 'Salvar Reembolso'}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── Modal: Editar Reembolso ── */}
      {editandoLanc && (
        <div onClick={e => e.target === e.currentTarget && setEditandoLanc(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: '100%', maxWidth: 460, boxShadow: '0 24px 64px rgba(0,0,0,0.2)' }}>
            <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 4, color: '#1a2233' }}>✏️ Editar Reembolso</div>
            <div style={{ fontSize: 13, color: cores.muted, marginBottom: 20 }}>{editandoLanc.usuario_nome}</div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>DATA *</label>
                <input type="date" value={editandoLanc.data}
                  onChange={e => setEditandoLanc(p => ({ ...p, data: e.target.value }))} style={inputStyle} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>VALOR (R$) *</label>
                <input type="number" step="0.01" placeholder="0,00" value={editandoLanc.valor}
                  onChange={e => setEditandoLanc(p => ({ ...p, valor: e.target.value }))} style={inputStyle} />
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>CATEGORIA *</label>
              {categorias.length > 0 ? (
                <select value={editandoLanc.categoria}
                  onChange={e => setEditandoLanc(p => ({ ...p, categoria: e.target.value }))} style={inputStyle}>
                  <option value="">— Selecionar —</option>
                  {categorias.map(c => <option key={c.id} value={c.nome}>{iconeEmoji(c.icone)} {c.nome}</option>)}
                </select>
              ) : (
                <input placeholder="Ex: Alimentação" value={editandoLanc.categoria}
                  onChange={e => setEditandoLanc(p => ({ ...p, categoria: e.target.value }))} style={inputStyle} />
              )}
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>DESCRIÇÃO (opcional)</label>
              <input placeholder="Ex: Almoço com cliente" value={editandoLanc.descricao}
                onChange={e => setEditandoLanc(p => ({ ...p, descricao: e.target.value }))} style={inputStyle} />
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setEditandoLanc(null)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={excluirLanc} style={{ padding: '9px 14px', background: cores.red, color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>🗑️</button>
              <button onClick={salvarEdicao} disabled={salvandoEdicao} style={{ ...btnPrimary, flex: 2 }}>
                {salvandoEdicao ? 'Salvando...' : 'Salvar Alterações'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
function AbaSalarios({ toast }) {
  const [salarios, setSalarios] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ usuario_id: '', nome: '', salario_base: '', pro_labore: '', quota: '', tipo: 'funcionario', decimo_terceiro: '', ferias: '', data_inicio: '', data_fim: '' });
  const [showForm, setShowForm] = useState(false);

  // Refs para navegação com Enter
  const refNome      = useRef(null);
  const refSalario   = useRef(null);
  const refProLabore = useRef(null);
  const refQuota     = useRef(null);
  const refDec       = useRef(null);
  const refFerias    = useRef(null);
  const ir = (ref) => ref.current?.focus();

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    try {
      const [sal, usrs] = await Promise.all([api.get('/salarios'), api.get('/usuarios')]);
      setSalarios(sal.data);
      setUsuarios(usrs.data);
    } catch {}
  };

  const salvar = async () => {
    if (!form.nome) { toast('Informe o nome', 'error'); return; }
    try {
      if (editando) {
        await api.patch(`/salarios/${editando}`, form);
        toast('Atualizado!', 'success');
      } else {
        await api.post('/salarios', form);
        toast('Cadastrado!', 'success');
      }
      setForm({ usuario_id: '', nome: '', salario_base: '', pro_labore: '', quota: '', tipo: 'funcionario', decimo_terceiro: '', ferias: '', data_inicio: '', data_fim: '' });
      setEditando(null);
      setShowForm(false);
      carregar();
    } catch { toast('Erro ao salvar.', 'error'); }
  };

  const editar = (s) => {
    setForm({
      usuario_id: s.usuario_id || '',
      nome: s.nome,
      salario_base: s.salario_base,
      pro_labore: s.pro_labore || '',
      quota: s.quota || '',
      tipo: s.tipo,
      decimo_terceiro: s.decimo_terceiro || '',
      ferias: s.ferias || '',
      data_inicio: s.data_inicio ? s.data_inicio.substring(0, 10) : '',
      data_fim: s.data_fim ? s.data_fim.substring(0, 10) : '',
    });
    setEditando(s.id);
    setShowForm(true);
  };

  // Encerra a partir de hoje em vez de desativar — mantém o funcionário/sócio
  // no histórico dos meses já fechados (Fechamento), só some dos meses futuros.
  const encerrar = async (id) => {
    try {
      const hoje = new Date().toISOString().substring(0, 10);
      await api.patch(`/salarios/${id}`, { data_fim: hoje });
      toast('Encerrado a partir de hoje.', 'success');
      carregar();
    } catch { toast('Erro ao encerrar.', 'error'); }
  };

  const funcionarios = salarios.filter(s => s.tipo === 'funcionario');
  const socios = salarios.filter(s => s.tipo === 'socio');
  const totalFolha = salarios.reduce((acc, s) => acc + Number(s.salario_base || 0) + Number(s.pro_labore || 0) + Number(s.quota || 0), 0);

  const TabelaSalarios = ({ lista, titulo }) => (
    <Card>
      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 16, color: cores.navyD }}>{titulo}</div>
      {lista.length === 0 && <p style={{ color: cores.muted, fontSize: 13 }}>Nenhum cadastrado.</p>}
      {lista.map(s => (
        <div key={s.id} style={{ padding: '12px 0', borderBottom: `1px solid ${cores.border}` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{s.nome}</div>
              <div style={{ fontSize: 12, color: cores.muted, marginTop: 4, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                {Number(s.salario_base) > 0 && <span>Salário: <strong>{fmt(s.salario_base)}</strong></span>}
                {Number(s.pro_labore) > 0 && <span>Pró-labore: <strong>{fmt(s.pro_labore)}</strong></span>}
                {Number(s.quota) > 0 && <span>Quota: <strong>{fmt(s.quota)}</strong></span>}
              </div>
              {(s.data_inicio || s.data_fim) && (
                <div style={{ fontSize: 11, color: cores.muted, marginTop: 4, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                  {s.data_inicio && <span>Início: {new Date(s.data_inicio).toLocaleDateString('pt-BR')}</span>}
                  {s.data_fim && <span style={{ color: cores.red, fontWeight: 600 }}>Encerrado: {new Date(s.data_fim).toLocaleDateString('pt-BR')}</span>}
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => editar(s)} style={{ padding: '5px 10px', background: '#eef2ff', color: '#2563eb', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>✏️</button>
              <button
                title="Encerra a partir de hoje, mantém no histórico dos meses anteriores"
                onClick={() => encerrar(s.id)}
                style={{ padding: '5px 10px', background: '#fde8e8', color: cores.red, border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>⏹️</button>
            </div>
          </div>
        </div>
      ))}
    </Card>
  );

  return (
    <div>
      {/* Resumo */}
      <Card style={{ padding: '16px 20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 12, color: cores.muted, fontWeight: 600, textTransform: 'uppercase' }}>Total Folha</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: cores.orange }}>{fmt(totalFolha)}</div>
          </div>
          <button onClick={() => { setShowForm(true); setEditando(null); setForm({ usuario_id: '', nome: '', salario_base: '', pro_labore: '', quota: '', tipo: 'funcionario', decimo_terceiro: '', ferias: '', data_inicio: '', data_fim: '' }); }} style={btnPrimary}>
            + Adicionar
          </button>
        </div>
      </Card>

      {/* Formulário */}
      {showForm && (
        <Card>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 16 }}>{editando ? 'Editar' : 'Novo'} cadastro</div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>TIPO</label>
            <select value={form.tipo} onChange={e => setForm(p => ({ ...p, tipo: e.target.value }))} style={inputStyle}>
              <option value="funcionario">Funcionário</option>
              <option value="socio">Sócio</option>
            </select>
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>USUÁRIO DO SISTEMA (opcional)</label>
            <select value={form.usuario_id} onChange={e => {
              const u = usuarios.find(u => u.id === parseInt(e.target.value));
              setForm(p => ({ ...p, usuario_id: e.target.value, nome: u ? u.nome : p.nome }));
            }} style={inputStyle}>
              <option value="">— Selecionar usuário —</option>
              {usuarios.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
            </select>
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>NOME</label>
            <input
              ref={refNome}
              value={form.nome}
              onChange={e => setForm(p => ({ ...p, nome: e.target.value }))}
              onKeyDown={e => e.key === 'Enter' && ir(refSalario)}
              placeholder="Nome completo"
              style={inputStyle}
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>SALÁRIO BASE</label>
              <input ref={refSalario} type="number" step="0.01" value={form.salario_base}
                onChange={e => setForm(p => ({ ...p, salario_base: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && ir(refProLabore)}
                placeholder="0,00" style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>PRÓ-LABORE</label>
              <input ref={refProLabore} type="number" step="0.01" value={form.pro_labore}
                onChange={e => setForm(p => ({ ...p, pro_labore: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && ir(refQuota)}
                placeholder="0,00" style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>QUOTA</label>
              <input ref={refQuota} type="number" step="0.01" value={form.quota}
                onChange={e => setForm(p => ({ ...p, quota: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && ir(refDec)}
                placeholder="0,00" style={inputStyle} />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>13° SALÁRIO</label>
              <input ref={refDec} type="number" step="0.01" value={form.decimo_terceiro}
                onChange={e => setForm(p => ({ ...p, decimo_terceiro: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && ir(refFerias)}
                placeholder="0,00" style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>FÉRIAS</label>
              <input ref={refFerias} type="number" step="0.01" value={form.ferias}
                onChange={e => setForm(p => ({ ...p, ferias: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && salvar()}
                placeholder="0,00" style={inputStyle} />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>INÍCIO (opcional)</label>
              <input type="date" value={form.data_inicio}
                onChange={e => setForm(p => ({ ...p, data_inicio: e.target.value }))}
                style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4 }}>ENCERRAMENTO (opcional)</label>
              <input type="date" value={form.data_fim}
                onChange={e => setForm(p => ({ ...p, data_fim: e.target.value }))}
                style={inputStyle} />
            </div>
          </div>
          <div style={{ fontSize: 11, color: cores.muted, marginTop: -8, marginBottom: 16 }}>
            Deixe em branco para valer em todos os meses. Preencha "Encerramento" para parar de aparecer no Fechamento a partir daquele mês, sem perder o histórico.
          </div>

          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={() => { setShowForm(false); setEditando(null); }} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
            <button onClick={salvar} style={{ ...btnPrimary, flex: 2 }}>Salvar</button>
          </div>
        </Card>
      )}

      <TabelaSalarios lista={funcionarios} titulo="👥 Funcionários" />
      <TabelaSalarios lista={socios} titulo="🤝 Sócios" />
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ──────────────────────────────────────────────────────

// ── MODAL DETALHE NOTA FISCAL ────────────────────────────────────────────────
function ModalDetalheNota({ nota, onClose, toast, onAtualizar }) {
  const [abaModal, setAbaModal] = useState('basico');
  const [justificativa, setJustificativa] = useState('');
  const [cancelando, setCancelando] = useState(false);
  const [consultando, setConsultando] = useState(false);
  const [notaAtual, setNotaAtual] = useState(nota);

  // Mantém notaAtual em sincronia se o modal for reaberto com outra nota
  useEffect(() => { setNotaAtual(nota); }, [nota?.id]);

  // Consulta a Focus e atualiza o modal SEM fechar (mostra o resultado — inclusive erro — na hora)
  const consultar = async () => {
    if (!notaAtual) return;
    setConsultando(true);
    try {
      const { data } = await api.get(`/notas/${notaAtual.id}/consultar`);
      setNotaAtual(prev => ({ ...prev, ...data }));
      onAtualizar(); // atualiza a lista em segundo plano, sem fechar o modal
      if (data.status === 'processando') {
        toast('Ainda processando na Focus NFe. Tente novamente em instantes.', 'success');
      } else {
        toast('Status atualizado!', 'success');
      }
    } catch { toast('Erro ao consultar', 'error'); }
    setConsultando(false);
  };

  // Ao abrir o modal com uma nota "processando", consulta automaticamente uma vez
  useEffect(() => {
    if (nota && nota.status === 'processando') {
      consultar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nota?.id]);

  if (!nota) return null;

  const fmtValor = (v) => v ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—';
  const fmtData  = (iso) => iso ? new Date(iso).toLocaleDateString('pt-BR') : '—';

  const STATUS_BADGE = {
    processando: { label: 'Processando', bg: '#e0f2fe', color: '#0369a1' },
    autorizada:  { label: 'Emitido',     bg: '#d1fae5', color: '#065f46' },
    rejeitada:   { label: 'Rejeitada',   bg: '#fee2e2', color: '#991b1b' },
    cancelada:   { label: 'Cancelado',   bg: '#f3f4f6', color: '#4b5563' },
    erro:        { label: 'Erro',        bg: '#fef3c7', color: '#92400e' },
  };
  const badge = STATUS_BADGE[notaAtual.status] || STATUS_BADGE.processando;

  const dadosEnvio = notaAtual.dados_envio ? (typeof notaAtual.dados_envio === 'string' ? JSON.parse(notaAtual.dados_envio) : notaAtual.dados_envio) : {};
  const itens = dadosEnvio.items || [];
  const isNFe = notaAtual.tipo === 'nfe';
  const isCte = notaAtual.tipo === 'cte';

  const cancelar = async () => {
    if (!justificativa || justificativa.length < 15) {
      toast('Justificativa deve ter ao menos 15 caracteres', 'error'); return;
    }
    if (!window.confirm('Confirma o cancelamento desta nota?')) return;
    setCancelando(true);
    try {
      await api.post(`/notas/${notaAtual.id}/cancelar`, { justificativa });
      toast('Nota cancelada!', 'success');
      onAtualizar();
      onClose();
    } catch (e) { toast(e?.response?.data?.erro || 'Erro ao cancelar', 'error'); }
    setCancelando(false);
  };

  const abasModal = isCte
    ? [
        { key: 'basico',      label: '📋 Dados Básicos' },
        { key: 'destinatario',label: '👤 Destinatário' },
        { key: 'produto',     label: '🚚 Transporte' },
      ]
    : [
        { key: 'basico',      label: '📋 Dados Básicos' },
        { key: 'destinatario',label: '👤 Destinatário' },
        { key: 'produto',     label: isNFe ? '📦 Produtos' : '🔧 Serviços' },
        { key: 'desp',        label: '💰 Outras Despesas' },
        { key: 'frete',       label: '🚚 Frete' },
      ];

  const labelM = { fontSize: 11, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4, textTransform: 'uppercase' };
  const valM   = { fontSize: 14, color: cores.navy, fontWeight: 500 };

  const Campo = ({ label, valor }) => (
    <div style={{ marginBottom: 14 }}>
      <span style={labelM}>{label}</span>
      <div style={valM}>{valor || '—'}</div>
    </div>
  );

  return (
    <div onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 680, maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 64px rgba(0,0,0,0.25)' }}>

        {/* Header */}
        <div style={{ padding: '18px 24px', borderBottom: `1px solid ${cores.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ fontWeight: 800, fontSize: 16, color: cores.navy }}>
              {isNFe ? '📦 NF-e' : isCte ? '🚚 CT-e' : '🔧 NFS-e'} {notaAtual.numero_nota ? `Nº ${notaAtual.numero_nota}` : '(sem número)'}
            </div>
            <span style={{ background: badge.bg, color: badge.color, padding: '3px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>{badge.label}</span>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: cores.muted }}>✕</button>
        </div>

        {/* Sub-abas */}
        <div style={{ display: 'flex', gap: 4, padding: '12px 24px 0', borderBottom: `1px solid ${cores.border}`, overflowX: 'auto' }}>
          {abasModal.map(a => (
            <button key={a.key} onClick={() => setAbaModal(a.key)} style={{
              padding: '8px 14px', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 12, whiteSpace: 'nowrap',
              borderBottom: abaModal === a.key ? `3px solid ${cores.orange}` : '3px solid transparent',
              background: 'none', color: abaModal === a.key ? cores.orange : cores.muted,
            }}>{a.label}</button>
          ))}
        </div>

        {/* Conteúdo */}
        <div style={{ overflowY: 'auto', padding: '20px 24px', flex: 1 }}>

          {/* Dados Básicos */}
          {abaModal === 'basico' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
                <Campo label="Tipo" valor={isNFe ? 'NF-e (Produto)' : isCte ? 'CT-e (Transporte)' : 'NFS-e (Serviço)'} />
                <Campo label="Número" valor={notaAtual.numero_nota} />
                <Campo label="Série" valor={notaAtual.serie} />
                <Campo label="Chave de Acesso" valor={notaAtual.chave_acesso} />
                <Campo label="Data de Emissão" valor={fmtData(notaAtual.criado_em)} />
                <Campo label="Valor Total" valor={fmtValor(notaAtual.valor_total)} />
                <Campo label="Orçamento" valor={notaAtual.orcamento_id ? `#${notaAtual.orcamento_numero || notaAtual.orcamento_id}` : null} />
                <Campo label="Referência Focus" valor={notaAtual.ref_focus} />
              </div>
              {notaAtual.mensagem_erro && (
                <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, padding: '12px 16px', marginTop: 8 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#991b1b', marginBottom: 4 }}>ERRO / REJEIÇÃO</div>
                  <div style={{ fontSize: 13, color: '#991b1b' }}>{notaAtual.mensagem_erro}</div>
                </div>
              )}
              {/* Botões de ação */}
              <div style={{ display: 'flex', gap: 8, marginTop: 20, flexWrap: 'wrap' }}>
                {notaAtual.status === 'processando' && (
                  <button onClick={consultar} disabled={consultando} style={{ ...btnGhost, fontSize: 13 }}>
                    {consultando ? 'Consultando...' : '🔄 Atualizar Status'}
                  </button>
                )}
                {notaAtual.url_pdf && (
                  <a href={notaAtual.url_pdf} target="_blank" rel="noreferrer"
                    style={{ ...btnGhost, fontSize: 13, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                    📄 {isCte ? 'DACTE / PDF' : 'DANFE / PDF'}
                  </a>
                )}
                {notaAtual.url_xml && (
                  <a href={notaAtual.url_xml} target="_blank" rel="noreferrer"
                    style={{ ...btnGhost, fontSize: 13, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                    📋 Download XML
                  </a>
                )}
              </div>
              {/* Cancelamento */}
              {notaAtual.status === 'autorizada' && (
                <div style={{ marginTop: 20, padding: 16, background: '#fff8f0', borderRadius: 10, border: `1px solid ${cores.border}` }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: cores.muted, marginBottom: 8 }}>CANCELAR NOTA</div>
                  <input value={justificativa} onChange={e => setJustificativa(e.target.value)}
                    placeholder="Justificativa (mín. 15 caracteres)..."
                    style={{ ...inputStyle, marginBottom: 8 }} />
                  <button onClick={cancelar} disabled={cancelando}
                    style={{ padding: '8px 18px', background: cores.red, color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
                    {cancelando ? 'Cancelando...' : '🚫 Cancelar Nota'}
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Destinatário */}
          {abaModal === 'destinatario' && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
              {/* NFS-e suporta dois formatos: aninhado (novo) e raiz (antigo).
                  NF-e e CT-e usam o mesmo padrão flat (nome_destinatario, cnpj_destinatario...). */}
              <Campo label="Nome / Razão Social" valor={(isNFe || isCte)
                ? dadosEnvio.nome_destinatario
                : dadosEnvio.tomador?.razao_social || dadosEnvio.tomador_razao_social} />
              <Campo label="CNPJ" valor={(isNFe || isCte)
                ? dadosEnvio.cnpj_destinatario
                : dadosEnvio.tomador?.cnpj || dadosEnvio.tomador_cnpj} />
              <Campo label="CPF" valor={(isNFe || isCte)
                ? dadosEnvio.cpf_destinatario
                : dadosEnvio.tomador?.cpf || dadosEnvio.tomador_cpf} />
              <Campo label="Email" valor={(isNFe || isCte)
                ? dadosEnvio.email_destinatario
                : dadosEnvio.tomador?.email || dadosEnvio.tomador_email} />
              <Campo label="Logradouro" valor={(isNFe || isCte)
                ? dadosEnvio.logradouro_destinatario
                : dadosEnvio.tomador?.endereco?.logradouro || dadosEnvio.tomador_endereco} />
              <Campo label="Bairro" valor={(isNFe || isCte)
                ? dadosEnvio.bairro_destinatario
                : dadosEnvio.tomador?.endereco?.bairro || dadosEnvio.tomador_bairro} />
              <Campo label="Município" valor={(isNFe || isCte)
                ? dadosEnvio.municipio_destinatario
                : dadosEnvio.tomador?.endereco?.municipio || dadosEnvio.tomador_municipio} />
              <Campo label="UF" valor={(isNFe || isCte)
                ? dadosEnvio.uf_destinatario
                : dadosEnvio.tomador?.endereco?.uf || dadosEnvio.tomador_uf} />
              <Campo label="CEP" valor={(isNFe || isCte)
                ? dadosEnvio.cep_destinatario
                : dadosEnvio.tomador?.endereco?.cep || dadosEnvio.tomador_cep} />
            </div>
          )}

          {/* Produtos / Serviços / Transporte */}
          {abaModal === 'produto' && (
            <div>
              {isCte ? (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
                  <Campo label="Remetente" valor={dadosEnvio.nome_remetente} />
                  <Campo label="CNPJ/CPF Remetente" valor={dadosEnvio.cnpj_remetente || dadosEnvio.cpf_remetente} />
                  <Campo label="Município de Início" valor={dadosEnvio.municipio_inicio ? `${dadosEnvio.municipio_inicio} - ${dadosEnvio.uf_inicio || ''}` : null} />
                  <Campo label="Município de Fim" valor={dadosEnvio.municipio_fim ? `${dadosEnvio.municipio_fim} - ${dadosEnvio.uf_fim || ''}` : null} />
                  <Campo label="RNTRC" valor={dadosEnvio.modal_rodoviario?.rntrc} />
                  <Campo label="Produto Predominante" valor={dadosEnvio.produto_predominante} />
                  <Campo label="CFOP" valor={dadosEnvio.cfop} />
                  <Campo label="Natureza da Operação" valor={dadosEnvio.natureza_operacao} />
                  <Campo label="Valor Total da Carga" valor={fmtValor(dadosEnvio.valor_total_carga)} />
                  <Campo label="Valor da Prestação" valor={fmtValor(dadosEnvio.valor_total)} />
                </div>
              ) : isNFe ? (
                itens.length === 0 ? <div style={{ color: cores.muted }}>Sem itens.</div> : (
                  <div style={{ border: `1px solid ${cores.border}`, borderRadius: 10, overflow: 'hidden' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 80px 100px 100px 80px', gap: 8, padding: '10px 14px', background: '#f8fafc', fontSize: 11, fontWeight: 700, color: cores.muted, textTransform: 'uppercase' }}>
                      <span>Descrição</span><span>Qtd</span><span>Unitário</span><span>Total</span><span>NCM</span>
                    </div>
                    {itens.map((item, i) => (
                      <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 80px 100px 100px 80px', gap: 8, padding: '10px 14px', borderTop: `1px solid ${cores.border}`, fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}>{item.descricao}</span>
                        <span>{item.quantidade_comercial}</span>
                        <span>{Number(item.valor_unitario_comercial || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                        <span style={{ fontWeight: 700 }}>{Number(item.valor_bruto || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                        <span style={{ color: cores.muted }}>{item.codigo_ncm || '—'}</span>
                      </div>
                    ))}
                    <div style={{ padding: '10px 14px', borderTop: `1px solid ${cores.border}`, display: 'flex', justifyContent: 'flex-end', gap: 8, fontWeight: 700, fontSize: 14 }}>
                      <span>Total:</span>
                      <span style={{ color: cores.navy }}>{fmtValor(notaAtual.valor_total)}</span>
                    </div>
                  </div>
                )
              ) : (
                <div>
                  {/* Suporta formato aninhado (novo: servico.campo) e raiz (antigo: campo) */}
                  <Campo label="Discriminação dos Serviços"
                    valor={dadosEnvio.servico?.discriminacao || dadosEnvio.discriminacao} />
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
                    <Campo label="Valor dos Serviços"
                      valor={fmtValor(dadosEnvio.servico?.valor_servicos ?? dadosEnvio.valor_servicos)} />
                    <Campo label="Código LC 116"
                      valor={dadosEnvio.servico?.item_lista_servico || dadosEnvio.item_lista_servico} />
                    <Campo label="Natureza da Operação" valor={dadosEnvio.natureza_operacao} />
                    <Campo label="Optante Simples"
                      valor={dadosEnvio.optante_simples_nacional === true || dadosEnvio.optante_simples_nacional === '1' ? 'Sim' : 'Não'} />
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Outras Despesas */}
          {abaModal === 'desp' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
                <Campo label="Valor do Frete" valor={dadosEnvio.valor_frete ? fmtValor(dadosEnvio.valor_frete) : 'R$ 0,00'} />
                <Campo label="Valor do Seguro" valor={dadosEnvio.valor_seguro ? fmtValor(dadosEnvio.valor_seguro) : 'R$ 0,00'} />
                <Campo label="Outras Despesas" valor={dadosEnvio.valor_outros ? fmtValor(dadosEnvio.valor_outros) : 'R$ 0,00'} />
                <Campo label="Desconto" valor={dadosEnvio.valor_desconto ? fmtValor(dadosEnvio.valor_desconto) : 'R$ 0,00'} />
              </div>
              <div style={{ color: cores.muted, fontSize: 13, marginTop: 8 }}>Despesas adicionais além do valor dos produtos/serviços.</div>
            </div>
          )}

          {/* Frete */}
          {abaModal === 'frete' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
                <Campo label="Modalidade do Frete" valor={
                  dadosEnvio.modalidade_frete === '9' ? '9 — Sem ocorrência de transporte' :
                  dadosEnvio.modalidade_frete === '0' ? '0 — Emitente' :
                  dadosEnvio.modalidade_frete === '1' ? '1 — Destinatário' :
                  dadosEnvio.modalidade_frete || '—'
                } />
                <Campo label="Valor do Frete" valor={dadosEnvio.valor_frete ? fmtValor(dadosEnvio.valor_frete) : 'R$ 0,00'} />
              </div>
              <div style={{ color: cores.muted, fontSize: 13, marginTop: 8 }}>Informações de transporte desta nota fiscal.</div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '14px 24px', borderTop: `1px solid ${cores.border}`, display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ ...btnGhost, fontSize: 13 }}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

// ── ABA NOTAS FISCAIS ─────────────────────────────────────────────────────────
function AbaNotasFiscais({ toast }) {
  const [subAba, setSubAba] = useState('nfse');
  const [notas, setNotas] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [busca, setBusca] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const [pagina, setPagina] = useState(1);
  const [reenviandoId, setReenviandoId] = useState(null);
  const POR_PAGINA = 10;

  // Checkboxes para exportar XML / ações em lote
  const [selecionadas, setSelecionadas] = useState([]);
  // Progresso das ações em lote (Atualizar Status / Excluir), que agora podem
  // processar centenas/milhares de notas de uma vez em pedaços (chunks) —
  // mostra "processando X de Y" em vez de travar a tela sem feedback.
  const [progressoLote, setProgressoLote] = useState(null); // { acao, feito, total } | null

  // Modal detalhe (duplo clique)
  const [notaDetalhe, setNotaDetalhe] = useState(null);

  // Nova Nota Fiscal (dropdown): individual avulsa ou importação em massa
  const [showDropdownNova, setShowDropdownNova] = useState(false);
  const [showAvulsa, setShowAvulsa] = useState(false);
  const [showImportar, setShowImportar] = useState(false);
  const [showEnviarEmails, setShowEnviarEmails] = useState(false);
  const [showCte, setShowCte] = useState(false);


  useEffect(() => { carregar({ atualizarProcessando: true }); }, [subAba]);

  const carregar = async ({ atualizarProcessando = false } = {}) => {
    setCarregando(true);
    setPagina(1);
    setSelecionadas([]);
    try {
      const r = await api.get(`/notas/tipo/${subAba}`);
      const lista = r.data || [];
      setNotas(lista);

      // Ao entrar na aba ou trocar sub-aba: consulta automaticamente as notas Processando
      if (atualizarProcessando) {
        const processando = lista.filter(n => n.status === 'processando');
        if (processando.length > 0) {
          await Promise.allSettled(processando.map(n => api.get(`/notas/${n.id}/consultar`)));
          // Recarrega após atualizar status
          const r2 = await api.get(`/notas/tipo/${subAba}`);
          setNotas(r2.data || []);
        }
      }
    } catch { setNotas([]); }
    setCarregando(false);
  };

  const fmtData  = (iso) => iso ? new Date(iso).toLocaleDateString('pt-BR') : '—';
  const fmtValor = (v) => v ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—';

  const STATUS_BADGE = {
    processando: { label: 'Processando', bg: '#e0f2fe', color: '#0369a1' },
    autorizada:  { label: 'Emitido',     bg: '#d1fae5', color: '#065f46' },
    rejeitada:   { label: 'Rejeitada',   bg: '#fee2e2', color: '#991b1b' },
    cancelada:   { label: 'Cancelado',   bg: '#f3f4f6', color: '#4b5563' },
    erro:        { label: 'Erro',        bg: '#fef3c7', color: '#92400e' },
  };

  const filtradas = notas.filter(n => {
    const q = busca.toLowerCase();
    const matchBusca = !q || (n.numero_nota || '').includes(q) || (n.cliente_nome || '').toLowerCase().includes(q);
    const matchStatus = !filtroStatus || n.status === filtroStatus;
    return matchBusca && matchStatus;
  });

  const totalPags = Math.ceil(filtradas.length / POR_PAGINA);
  const paginadas = filtradas.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);
  const totalEmitido = notas.filter(n => n.status === 'autorizada')
    .reduce((acc, n) => acc + (parseFloat(n.valor_total) || 0), 0);

  // Toggle checkbox
  const toggleSel = (id) => setSelecionadas(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const toggleTodos = () => {
    const ids = paginadas.map(n => n.id);
    const todos = ids.every(id => selecionadas.includes(id));
    setSelecionadas(todos ? selecionadas.filter(id => !ids.includes(id)) : [...new Set([...selecionadas, ...ids])]);
  };
  // Seleciona TODAS as notas que batem com o filtro/busca atual, não só as 10
  // da página visível — a lista completa já está em memória (client-side),
  // então não precisa de chamada nova ao backend pra isso.
  const selecionarTodasFiltradas = () => setSelecionadas(filtradas.map(n => n.id));

  // Exportar XML das selecionadas
  const exportarXML = async () => {
    const notasSel = notas.filter(n => selecionadas.includes(n.id) && n.url_xml);
    if (notasSel.length === 0) {
      toast('Selecione ao menos uma nota com XML disponível.', 'error'); return;
    }
    for (const n of notasSel) {
      window.open(n.url_xml, '_blank', 'noopener,noreferrer');
      await new Promise(r => setTimeout(r, 400));
    }
    toast(`${notasSel.length} XML(s) exportado(s)!`, 'success');
  };

  // Atualizar status em lote das selecionadas — manda em pedaços de 150 ids
  // por chamada (o backend processa cada pedaço com pausa entre consultas à
  // Focus) e mostra progresso, porque agora dá pra selecionar milhares de
  // notas de uma vez (ver selecionarTodasFiltradas), não só as 10 da página.
  const CHUNK_LOTE = 150;
  const atualizarStatus = async () => {
    const ids = notas.filter(n => selecionadas.includes(n.id) && n.status === 'processando').map(n => n.id);
    if (ids.length === 0) { toast('Nenhuma nota "Processando" selecionada.', 'error'); return; }
    setProgressoLote({ acao: 'Atualizando status', feito: 0, total: ids.length });
    let atualizadas = 0, erros = 0;
    for (let i = 0; i < ids.length; i += CHUNK_LOTE) {
      const pedaco = ids.slice(i, i + CHUNK_LOTE);
      try {
        const { data } = await api.post('/notas/consultar-lote', { ids: pedaco });
        atualizadas += data.atualizadas || 0;
        erros += data.erros || 0;
      } catch {
        erros += pedaco.length;
      }
      setProgressoLote({ acao: 'Atualizando status', feito: Math.min(i + CHUNK_LOTE, ids.length), total: ids.length });
    }
    setProgressoLote(null);
    toast(`${atualizadas} nota(s) atualizada(s)${erros > 0 ? `, ${erros} com erro` : ''}.`, erros > 0 ? 'error' : 'success');
    carregar();
  };

  // Excluir em lote as selecionadas (apenas erro/rejeitada/processando) — é só
  // um DELETE no banco (não chama a Focus), então resolve tudo numa chamada
  // só, mesmo com milhares de ids.
  const excluirSelecionadas = async () => {
    const elegíveis = notas.filter(n => selecionadas.includes(n.id) && ['erro', 'rejeitada', 'processando'].includes(n.status)).map(n => n.id);
    if (elegíveis.length === 0) { toast('Nenhuma nota excluível selecionada (apenas Erro, Rejeitada ou Processando podem ser excluídas).', 'error'); return; }
    if (!window.confirm(`Excluir ${elegíveis.length} nota(s)? Esta ação não pode ser desfeita.`)) return;
    setProgressoLote({ acao: 'Excluindo', feito: 0, total: elegíveis.length });
    try {
      const { data } = await api.post('/notas/excluir-lote', { ids: elegíveis });
      toast(`${data.excluidas} nota(s) excluída(s)!`, 'success');
    } catch {
      toast('Erro ao excluir notas.', 'error');
    }
    setProgressoLote(null);
    setSelecionadas([]);
    carregar();
  };

  const isMobNF = window.innerWidth < 700;
  // Desktop: checkbox | Nº | (Série só NF-e) | Destinatário | Orçamento | Emissão | Status | Valor
  // Mobile:  checkbox | Nº | Destinatário | Status
  const colsNfe  = isMobNF ? '28px 55px 1fr 80px' : '32px 70px 60px 1fr 120px 90px 110px 90px';
  const colsNfse = isMobNF ? '28px 55px 1fr 80px' : '32px 70px 1fr 120px 90px 110px 90px';
  // CT-e também tem série (mesma coluna do NF-e); "Destinatário" aqui mostra o destinatário da carga.
  const colsCte  = colsNfe;
  const cols = subAba === 'nfe' ? colsNfe : subAba === 'cte' ? colsCte : colsNfse;

  return (
    <div>
      {/* Sub-abas */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['nfse', '🔧 Notas Fiscais de Serviço'], ['nfe', '📦 Notas Fiscais de Produto'], ['cte', '🚚 Conhecimento de Transporte']].map(([k, l]) => (
          <button key={k} onClick={() => { setSubAba(k); setBusca(''); setFiltroStatus(''); setSelecionadas([]); }} style={{
            padding: '9px 20px', borderRadius: 20, border: 'none', cursor: 'pointer',
            fontWeight: 600, fontSize: 13,
            background: subAba === k ? cores.orange : '#f0f3f7',
            color: subAba === k ? 'white' : cores.muted,
          }}>{l}</button>
        ))}
      </div>

      {/* KPIs */}
      <div style={{ display: 'flex', gap: 14, marginBottom: 20, flexWrap: 'wrap' }}>
        {[
          { label: 'Total emitido', valor: fmtValor(totalEmitido), cor: cores.green },
          { label: 'Notas emitidas', valor: notas.filter(n => n.status === 'autorizada').length, cor: cores.navy },
          { label: 'Canceladas', valor: notas.filter(n => n.status === 'cancelada').length, cor: cores.red },
        ].map(({ label, valor, cor }) => (
          <Card key={label} style={{ flex: '1 1 160px', marginBottom: 0, padding: '14px 18px' }}>
            <div style={{ fontSize: 11, color: cores.muted, fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>{label}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: cor }}>{valor}</div>
          </Card>
        ))}
      </div>

      {/* Filtros + Ações */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        <input value={busca} onChange={e => { setBusca(e.target.value); setPagina(1); }}
          placeholder="Buscar por número ou destinatário..." style={{ ...inputStyle, maxWidth: 280 }} />
        <select value={filtroStatus} onChange={e => { setFiltroStatus(e.target.value); setPagina(1); }}
          style={{ ...inputStyle, maxWidth: 150 }}>
          <option value="">Todos os status</option>
          {Object.entries(STATUS_BADGE).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>

        {/* "+ Emitir CT-e" — apenas na aba de Transporte, formulário próprio (remetente/destinatário) */}
        {subAba === 'cte' && (
          <button onClick={() => setShowCte(true)} style={btnPrimary}>
            + Emitir CT-e
          </button>
        )}

        {/* "+ Nova Nota Fiscal" — apenas na aba de Serviço (fluxo de comissão avulsa/massa é NFS-e) */}
        {subAba === 'nfse' && (
          <div style={{ position: 'relative' }}>
            <button onClick={() => setShowDropdownNova(v => !v)} style={{ ...btnPrimary, display: 'flex', alignItems: 'center', gap: 6 }}>
              + Nova Nota Fiscal ▾
            </button>
            {showDropdownNova && (
              <>
                <div onClick={() => setShowDropdownNova(false)} style={{ position: 'fixed', inset: 0, zIndex: 10 }} />
                <div style={{ position: 'absolute', top: '110%', left: 0, background: 'white', border: `1px solid ${cores.border}`, borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 11, minWidth: 220, overflow: 'hidden' }}>
                  <button onClick={() => { setShowDropdownNova(false); setShowAvulsa(true); }}
                    style={{ width: '100%', textAlign: 'left', padding: '12px 16px', background: 'white', border: 'none', borderBottom: `1px solid ${cores.border}`, cursor: 'pointer', fontSize: 13, fontWeight: 600, color: cores.navy }}>
                    🧾 Emitir Individual
                    <div style={{ fontSize: 11, fontWeight: 400, color: cores.muted, marginTop: 2 }}>Nota avulsa, sem orçamento</div>
                  </button>
                  <button onClick={() => { setShowDropdownNova(false); setShowImportar(true); }}
                    style={{ width: '100%', textAlign: 'left', padding: '12px 16px', background: 'white', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: cores.navy }}>
                    📥 Emitir em Massa
                    <div style={{ fontSize: 11, fontWeight: 400, color: cores.muted, marginTop: 2 }}>Importar planilha de comissões</div>
                  </button>
                </div>
              </>
            )}
          </div>
        )}

        <button onClick={exportarXML} style={btnGhost} disabled={!!progressoLote}>
          Exportar XML {selecionadas.length > 0 ? `(${selecionadas.length})` : ''}
        </button>
        <button onClick={atualizarStatus} style={btnGhost} disabled={!!progressoLote}>
          Atualizar Status {selecionadas.filter(id => notas.find(n => n.id === id)?.status === 'processando').length > 0 ? `(${selecionadas.filter(id => notas.find(n => n.id === id)?.status === 'processando').length})` : ''}
        </button>
        {/* Envio manual de email — só NFS-e (avulsa/importação em massa não têm
            o fluxo de email por orçamento). Nunca automático de propósito: ver
            EnviarEmailsNotasModal — lotes grandes de uma vez tomam bloqueio do
            provedor de email. */}
        {subAba === 'nfse' && (
          <button onClick={() => setShowEnviarEmails(true)} style={btnGhost} disabled={!!progressoLote}>
            ✉️ Enviar Emails
          </button>
        )}
        <button onClick={excluirSelecionadas} style={{ ...btnGhost, color: '#e74c3c', borderColor: '#fca5a5' }} disabled={!!progressoLote}>
          Excluir {selecionadas.filter(id => notas.find(n => n.id === id && ['erro','rejeitada','processando'].includes(n.status))).length > 0 ? `(${selecionadas.filter(id => notas.find(n => n.id === id && ['erro','rejeitada','processando'].includes(n.status))).length})` : ''}
        </button>
      </div>

      {progressoLote ? (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 12, color: cores.muted, marginBottom: 4 }}>
            {progressoLote.acao}... {progressoLote.feito}/{progressoLote.total}
          </div>
          <div style={{ height: 6, background: '#f0f3f7', borderRadius: 3, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${(progressoLote.feito / progressoLote.total) * 100}%`, background: cores.orange, transition: 'width 0.2s' }} />
          </div>
        </div>
      ) : selecionadas.length > 0 && (
        <div style={{ fontSize: 12, color: cores.muted, marginBottom: 8, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <span>{selecionadas.length} nota(s) selecionada(s) — dê duplo clique em uma nota para ver detalhes</span>
          {filtradas.length > selecionadas.length && (
            <button onClick={selecionarTodasFiltradas} style={{ background: 'none', border: 'none', color: cores.orange, fontWeight: 700, fontSize: 12, cursor: 'pointer', padding: 0 }}>
              Selecionar todas as {filtradas.length} que batem com o filtro atual
            </button>
          )}
        </div>
      )}

      {/* Tabela */}
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        {/* Cabeçalho */}
        <div style={{ display: 'grid', gridTemplateColumns: cols, gap: 8, padding: '10px 16px', background: '#f8fafc', borderBottom: `1px solid ${cores.border}`, fontSize: 11, fontWeight: 700, color: cores.muted, textTransform: 'uppercase', alignItems: 'center' }}>
          <input type="checkbox"
            checked={paginadas.length > 0 && paginadas.every(n => selecionadas.includes(n.id))}
            onChange={toggleTodos}
            disabled={!!progressoLote}
            style={{ width: 15, height: 15, cursor: 'pointer' }} />
          <span>Nº</span>
          {!isMobNF && (subAba === 'nfe' || subAba === 'cte') && <span>Série</span>}
          <span>Destinatário</span>
          {!isMobNF && <span>Orçamento</span>}
          {!isMobNF && <span>Emissão</span>}
          <span>Status</span>
          {!isMobNF && <span>Valor</span>}
        </div>

        {carregando ? (
          <div style={{ padding: 40, textAlign: 'center', color: cores.muted }}>Carregando...</div>
        ) : paginadas.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: cores.muted }}>
            {busca || filtroStatus ? 'Nenhuma nota encontrada com esses filtros.' : `Nenhuma ${subAba === 'nfse' ? 'NFS-e' : subAba === 'cte' ? 'CT-e' : 'NF-e'} emitida ainda.`}
          </div>
        ) : paginadas.map((n, i) => {
          const badge = STATUS_BADGE[n.status] || STATUS_BADGE.processando;
          const sel = selecionadas.includes(n.id);
          return (
        <div key={n.id}
              onDoubleClick={() => setNotaDetalhe(n)}
              style={{ padding: '12px 16px', borderBottom: i < paginadas.length - 1 ? `1px solid ${cores.border}` : 'none', background: sel ? '#f0f7ff' : 'white', cursor: 'pointer', transition: 'background 0.15s' }}
              title="Duplo clique para ver detalhes"
            >
              {/* Linha de dados */}
              <div style={{ display: 'grid', gridTemplateColumns: cols, gap: 8, alignItems: 'center', fontSize: 13, marginBottom: 8 }}>
                <input type="checkbox" checked={sel} onChange={() => toggleSel(n.id)}
                  onClick={e => e.stopPropagation()}
                  style={{ width: 15, height: 15, cursor: 'pointer' }} />
                <span style={{ fontWeight: 700, color: cores.navy }}>{n.numero_nota || '—'}</span>
                {!isMobNF && (subAba === 'nfe' || subAba === 'cte') && <span style={{ color: cores.muted }}>{n.serie || '—'}</span>}
                <span style={{ color: cores.navy, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.cliente_nome || '—'}</span>
                  {n.origem_emissao === 'avulsa' && (
                    <span title="Nota avulsa, sem orçamento" style={{ flexShrink: 0, fontSize: 10, fontWeight: 700, color: cores.orange, background: '#fdece6', padding: '1px 6px', borderRadius: 20 }}>Avulsa</span>
                  )}
                  {n.origem_emissao === 'importacao_massa' && (
                    <span title="Emitida por importação em massa" style={{ flexShrink: 0, fontSize: 10, fontWeight: 700, color: '#0369a1', background: '#e0f2fe', padding: '1px 6px', borderRadius: 20 }}>Importada</span>
                  )}
                </span>
                {!isMobNF && (
                  <span style={{ color: cores.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {n.orcamento_id
                      ? `#${n.orcamento_numero || n.orcamento_id}`
                      : n.contrato_nome
                        ? <span title={n.contrato_nome}>📋 {n.contrato_nome.length > 14 ? n.contrato_nome.slice(0, 14) + '…' : n.contrato_nome}</span>
                        : '—'}
                  </span>
                )}
                {!isMobNF && <span style={{ color: cores.muted }}>{fmtData(n.criado_em)}</span>}
                <span>
                  <span style={{ background: badge.bg, color: badge.color, padding: '3px 8px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>
                    {badge.label}
                  </span>
                </span>
                {!isMobNF && <span style={{ fontWeight: 700, color: cores.navy }}>{fmtValor(n.valor_total)}</span>}
              </div>
              {/* Mobile: valor + data abaixo do status */}
              {isMobNF && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: cores.muted, paddingLeft: 23, marginBottom: 6 }}>
                  <span>{fmtData(n.criado_em)}</span>
                  <span style={{ fontWeight: 700, color: cores.navy }}>{fmtValor(n.valor_total)}</span>
                </div>
              )}

              {/* Linha de botões */}
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', paddingLeft: 23 }} onClick={e => e.stopPropagation()}>
                {/* NF-e e CT-e: link direto (DANFE/DACTE são públicos). NFS-e: sempre usa proxy autenticado do backend */}
                {n.status === 'autorizada' && (n.tipo === 'nfe' || n.tipo === 'cte') && n.url_pdf && (
                  <a href={n.url_pdf} target="_blank" rel="noreferrer"
                    style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', background: '#fef2f2', color: '#e74c3c', borderRadius: 6, fontSize: 12, textDecoration: 'none', fontWeight: 500 }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
                    PDF
                  </a>
                )}
                {/* NFS-e: backend retorna redirect_url (SP) ou pdf_base64 (outros municípios) */}
                {n.status === 'autorizada' && n.tipo === 'nfse' && (
                  <button onClick={async () => {
                    try {
                      const resp = await api.get(`/notas/${n.id}/pdf-nfse`);
                      const data = resp.data;
                      if (data.redirect_url) {
                        // Prefeitura de SP: abre URL pública direto
                        window.open(data.redirect_url, '_blank');
                      } else if (data.pdf_base64) {
                        // Outros municípios: converte base64 → blob → abre
                        const bytes = Uint8Array.from(atob(data.pdf_base64), c => c.charCodeAt(0));
                        const blob = new Blob([bytes], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);
                        window.open(url, '_blank');
                        setTimeout(() => URL.revokeObjectURL(url), 15000);
                      } else {
                        toast('PDF não disponível.', 'error');
                      }
                    } catch (e) {
                      const msg = e?.response?.data?.erro || 'Erro ao baixar PDF da NFS-e';
                      toast(msg, 'error');
                    }
                  }}
                    style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', background: '#fef2f2', color: '#e74c3c', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 500 }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
                    PDF
                  </button>
                )}
                {n.url_xml && (
                  <button onClick={() => window.open(n.url_xml, '_blank', 'noopener,noreferrer')}
                    style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', background: '#eef2ff', color: '#3730a3', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 500 }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                    XML
                  </button>
                )}
                {n.status === 'autorizada' && n.orcamento_id && (
                  <button disabled={reenviandoId === n.id} onClick={async () => {
                    setReenviandoId(n.id);
                    try {
                      const r = await api.post('/email-orcamento/enviar-nota', { orcamento_id: n.orcamento_id });
                      const destinos = r.data?.enviado_para?.join(', ') || 'cliente';
                      toast(`Nota reenviada para ${destinos} ✉️`, 'success');
                    } catch (e) { toast(e?.response?.data?.erro || 'Erro ao reenviar nota.', 'error'); }
                    setReenviandoId(null);
                  }}
                    style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', background: '#f0fdf4', color: '#15803d', border: 'none', borderRadius: 6, cursor: reenviandoId === n.id ? 'not-allowed' : 'pointer', fontSize: 12, fontWeight: 500, opacity: reenviandoId === n.id ? 0.6 : 1 }}>
                    {reenviandoId === n.id ? (
                      '⏳ Enviando...'
                    ) : (
                      <>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                        Reenviar
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          );
        })}

        {/* Paginação */}
        {totalPags > 1 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderTop: `1px solid ${cores.border}`, fontSize: 13, color: cores.muted }}>
            <span>Mostrando {(pagina - 1) * POR_PAGINA + 1} a {Math.min(pagina * POR_PAGINA, filtradas.length)} de {filtradas.length} itens</span>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => setPagina(1)} disabled={pagina === 1} style={{ ...btnGhost, padding: '6px 12px', fontSize: 12, opacity: pagina === 1 ? 0.4 : 1 }}>Primeiro</button>
              <button onClick={() => setPagina(p => Math.max(1, p - 1))} disabled={pagina === 1} style={{ ...btnGhost, padding: '6px 12px', fontSize: 12, opacity: pagina === 1 ? 0.4 : 1 }}>Anterior</button>
              <span style={{ padding: '6px 12px', fontWeight: 700, color: cores.navy }}>Página {pagina} de {totalPags}</span>
              <button onClick={() => setPagina(p => Math.min(totalPags, p + 1))} disabled={pagina === totalPags} style={{ ...btnGhost, padding: '6px 12px', fontSize: 12, opacity: pagina === totalPags ? 0.4 : 1 }}>Próxima</button>
              <button onClick={() => setPagina(totalPags)} disabled={pagina === totalPags} style={{ ...btnGhost, padding: '6px 12px', fontSize: 12, opacity: pagina === totalPags ? 0.4 : 1 }}>Último</button>
            </div>
          </div>
        )}
      </Card>

      {/* Modal detalhe */}
      {notaDetalhe && (
        <ModalDetalheNota
          nota={notaDetalhe}
          onClose={() => setNotaDetalhe(null)}
          toast={toast}
          onAtualizar={carregar}
        />
      )}

      {/* Modal: Nova Nota Fiscal — Emitir Individual (avulsa) */}
      {showAvulsa && (
        <NotaAvulsaModal
          toast={toast}
          onClose={() => setShowAvulsa(false)}
          onSucesso={() => { setShowAvulsa(false); carregar(); }}
        />
      )}

      {/* Modal: Nova Nota Fiscal — Emitir em Massa (planilha) */}
      {showImportar && (
        <ImportarNotasModal
          toast={toast}
          onClose={() => setShowImportar(false)}
          onSucesso={carregar}
        />
      )}

      {/* Modal: Envio manual de email das notas (avulsas/importação em massa),
          em lotes controlados pelo usuário — nunca automático na emissão. */}
      {showEnviarEmails && (
        <EnviarEmailsNotasModal
          toast={toast}
          onClose={() => setShowEnviarEmails(false)}
        />
      )}

      {/* Modal: Emitir CT-e (Conhecimento de Transporte) */}
      {showCte && (
        <CteModal
          toast={toast}
          onClose={() => setShowCte(false)}
          onSucesso={() => { setShowCte(false); carregar(); }}
        />
      )}
    </div>
  );
}


// ── ABA CONTAS A PAGAR / RECEBER ─────────────────────────────────────────────
function AbaContasFinanceiro({ tipo, toast }) {
  const titulo    = tipo === 'pagar' ? 'Contas a Pagar' : 'Contas a Receber';
  const corTitulo = tipo === 'pagar' ? cores.red : cores.green;

  const [lancamentos, setLancamentos] = useState([]);
  const [categorias, setCategorias]   = useState([]);
  const [carregando, setCarregando]   = useState(false);

  // Filtros
  const [busca, setBusca]             = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [periodoInicio, setPeriodoInicio] = useState('');
  const [periodoFim, setPeriodoFim]       = useState('');
  const [pagina, setPagina]           = useState(1);
  const POR_PAGINA = 13;

  // Modal novo/editar
  const [showModal, setShowModal]   = useState(false);
  const [editando, setEditando]     = useState(null);
  const [salvando, setSalvando]     = useState(false);
  const [form, setForm] = useState({
    descricao: '', valor: '', data_vencimento: '', categoria: '',
    status: 'pendente', observacao: '', recorrente: false,
    condicao: 'a_vista', parcelas: '2',
  });

  useEffect(() => { carregar(); }, [tipo]);

  const carregar = async () => {
    setCarregando(true);
    try {
      const [lanc, cats] = await Promise.all([
        api.get(`/financeiro/lancamentos?tipo=${tipo}`).catch(() => ({ data: [] })),
        api.get(`/financeiro/categorias?tipo=${tipo}`).catch(() => ({ data: [] })),
      ]);
      setLancamentos(lanc.data || []);
      setCategorias(cats.data || []);
    } catch {}
    setCarregando(false);
  };

  const abrirNovo = () => {
    setEditando(null);
    setForm({ descricao: '', valor: '', data_vencimento: '', categoria: '', status: 'pendente', observacao: '', recorrente: false, condicao: 'a_vista', parcelas: '2' });
    setShowModal(true);
  };

  const abrirEditar = (l) => {
    setEditando(l.id);
    setForm({
      descricao:       l.descricao || '',
      valor:           l.valor || '',
      data_vencimento: l.data_vencimento ? l.data_vencimento.substring(0, 10) : '',
      categoria:       l.categoria || '',
      status:          l.status || 'pendente',
      observacao:      l.observacao || '',
      recorrente:      l.recorrente || false,
      condicao:        'a_vista',
      parcelas:        '2',
    });
    setShowModal(true);
  };

  const salvar = async () => {
    if (!form.descricao || !form.valor || !form.data_vencimento) {
      toast('Preencha descrição, valor e vencimento.', 'error'); return;
    }
    setSalvando(true);
    try {
      if (editando) {
        // Edição continua sendo de um único lançamento — parcelamento só se
        // aplica na criação (dividir um lançamento existente em N exigiria
        // decidir o que fazer com o que já foi pago/recebido, então não é
        // oferecido aqui).
        const payload = { ...form, tipo, valor: parseFloat(form.valor) };
        await api.patch(`/financeiro/lancamentos/${editando}`, payload);
        toast('Atualizado!', 'success');
      } else if (form.condicao === 'parcelado') {
        const numParcelas = parseInt(form.parcelas) || 1;
        const valorTotal = parseFloat(form.valor);
        const valorParcela = Math.round((valorTotal / numParcelas) * 100) / 100;
        const [anoV, mesV, diaV] = form.data_vencimento.split('-').map(Number);

        for (let i = 0; i < numParcelas; i++) {
          // 1ª parcela no vencimento escolhido, demais +1 mês cada — usa
          // setMonth (não +30 dias fixos) para cair sempre no mesmo dia do
          // mês seguinte, como uma fatura normal.
          const dataBase = new Date(anoV, mesV - 1 + i, diaV);
          const pad = n => String(n).padStart(2, '0');
          const dataStr = `${dataBase.getFullYear()}-${pad(dataBase.getMonth() + 1)}-${pad(dataBase.getDate())}`;
          // Ajusta a última parcela para fechar exatamente o valor total,
          // absorvendo a diferença de centavos do arredondamento.
          const valorEssaParcela = i === numParcelas - 1
            ? Math.round((valorTotal - valorParcela * (numParcelas - 1)) * 100) / 100
            : valorParcela;

          await api.post('/financeiro/lancamentos', {
            tipo,
            descricao: `${form.descricao} (${i + 1}/${numParcelas})`,
            valor: valorEssaParcela,
            data_vencimento: dataStr,
            categoria: form.categoria,
            status: i === 0 ? form.status : 'pendente',
            observacao: form.observacao,
            recorrente: false,
          });
        }
        toast(`${numParcelas} parcelas criadas!`, 'success');
      } else {
        const payload = { ...form, tipo, valor: parseFloat(form.valor) };
        await api.post('/financeiro/lancamentos', payload);
        toast('Lançamento criado!', 'success');
      }
      setShowModal(false);
      carregar();
    } catch { toast('Erro ao salvar.', 'error'); }
    setSalvando(false);
  };

  const alterarStatus = async (id, status) => {
    try {
      await api.patch(`/financeiro/lancamentos/${id}`, { status });
      toast(status === 'pago' ? 'Baixado!' : status === 'recebido' ? 'Recebido!' : 'Status atualizado!', 'success');
      carregar();
    } catch { toast('Erro ao atualizar.', 'error'); }
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir este lançamento?')) return;
    try {
      await api.delete(`/financeiro/lancamentos/${id}`);
      toast('Excluído!', 'success');
      setShowModal(false);
      carregar();
    } catch { toast('Erro ao excluir.', 'error'); }
  };

  const STATUS_MAP = tipo === 'pagar'
    ? { pendente: { label: 'Pendente', bg: '#fff3cd', color: '#856404' }, pago:     { label: 'Pago',    bg: '#d1f5e0', color: '#155724' }, vencido:  { label: 'Vencido', bg: '#fde8e8', color: '#991b1b' } }
    : { pendente: { label: 'A Receber', bg: '#e0f2fe', color: '#0369a1' }, recebido: { label: 'Recebido', bg: '#d1f5e0', color: '#155724' }, vencido:  { label: 'Vencido',  bg: '#fde8e8', color: '#991b1b' } };

  const STATUS_BTN = tipo === 'pagar' ? 'pago' : 'recebido';
  const STATUS_BTN_LABEL = tipo === 'pagar' ? '✅ Dar Baixa' : '✅ Recebido';

  // Calcular status real considerando vencimento
  const statusReal = (l) => {
    if (l.status === 'pago' || l.status === 'recebido') return l.status;
    const hoje = new Date(); hoje.setHours(0,0,0,0);
    const venc = new Date(l.data_vencimento.substring(0,10) + 'T12:00:00');
    return venc < hoje ? 'vencido' : 'pendente';
  };

  const filtrados = lancamentos.filter(l => {
    const q = busca.toLowerCase();
    const matchBusca = !q || (l.descricao || '').toLowerCase().includes(q) || (l.categoria || '').toLowerCase().includes(q);
    const sr = statusReal(l);
    const matchStatus = !filtroStatus || sr === filtroStatus;
    const matchCat = !filtroCategoria || l.categoria === filtroCategoria;
    const data = l.data_vencimento ? new Date(l.data_vencimento.substring(0,10) + 'T12:00:00') : null;
    const matchInicio = !periodoInicio || !data || data >= new Date(periodoInicio + 'T00:00:00');
    const matchFim    = !periodoFim    || !data || data <= new Date(periodoFim    + 'T23:59:59');
    return matchBusca && matchStatus && matchCat && matchInicio && matchFim;
  });

  const totalPags = Math.ceil(filtrados.length / POR_PAGINA);
  const paginados = filtrados.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);

  const totalGeral   = filtrados.reduce((a, l) => a + parseFloat(l.valor || 0), 0);
  const totalPendente = filtrados.filter(l => statusReal(l) === 'pendente').reduce((a, l) => a + parseFloat(l.valor || 0), 0);
  const totalQuitado = filtrados.filter(l => l.status === 'pago' || l.status === 'recebido').reduce((a, l) => a + parseFloat(l.valor || 0), 0);
  const totalVencido = filtrados.filter(l => statusReal(l) === 'vencido').reduce((a, l) => a + parseFloat(l.valor || 0), 0);

  const labelStyle = { fontSize: 11, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4, textTransform: 'uppercase' };

  return (
    <div>
      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth < 700 ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: window.innerWidth < 700 ? 8 : 12, marginBottom: 16 }}>
        {[
          { label: 'Total', val: totalGeral,    cor: cores.navy  },
          { label: tipo === 'pagar' ? 'A Pagar' : 'A Receber', val: totalPendente, cor: corTitulo },
          { label: tipo === 'pagar' ? 'Pago'    : 'Recebido', val: totalQuitado,  cor: cores.green },
          { label: 'Vencido', val: totalVencido, cor: cores.red  },
        ].map(({ label, val, cor }) => (
          <div key={label} style={{ background: 'white', borderRadius: 14, padding: '14px 18px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', borderLeft: `4px solid ${cor}` }}>
            <div style={{ fontSize: 11, color: cores.muted, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 17, fontWeight: 800, color: cor }}>{fmt(val)}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <Card>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
          <input value={busca} onChange={e => { setBusca(e.target.value); setPagina(1); }}
            placeholder="Buscar por descrição ou categoria..."
            style={{ ...inputStyle }} />
          <select value={filtroCategoria} onChange={e => { setFiltroCategoria(e.target.value); setPagina(1); }} style={{ ...inputStyle }}>
            <option value="">Todas as categorias</option>
            {categorias.map(c => <option key={c.id} value={c.nome}>{c.nome}</option>)}
          </select>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
          <select value={filtroStatus} onChange={e => { setFiltroStatus(e.target.value); setPagina(1); }} style={{ ...inputStyle }}>
            <option value="">Todos os status</option>
            {Object.entries(STATUS_MAP).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
          <input type="date" value={periodoInicio} onChange={e => setPeriodoInicio(e.target.value)} style={{ ...inputStyle }} />
          <input type="date" value={periodoFim}    onChange={e => setPeriodoFim(e.target.value)}    style={{ ...inputStyle }} />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => { setBusca(''); setFiltroStatus(''); setFiltroCategoria(''); setPeriodoInicio(''); setPeriodoFim(''); setPagina(1); }} style={{ ...btnGhost, fontSize: 13 }}>
            Limpar filtros
          </button>
          <button onClick={abrirNovo} style={{ ...btnPrimary, marginLeft: 'auto' }}>
            + {tipo === 'pagar' ? 'Nova Conta a Pagar' : 'Nova Conta a Receber'}
          </button>
        </div>
      </Card>

      {/* Tabela */}
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        {/* Cabeçalho — só no desktop */}
        {window.innerWidth >= 700 && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 140px 110px 120px 110px', gap: 8, padding: '10px 16px', background: '#f8fafc', borderBottom: `1px solid ${cores.border}`, fontSize: 11, fontWeight: 700, color: cores.muted, textTransform: 'uppercase' }}>
            <span>Descrição / Categoria</span>
            <span>Vencimento</span>
            <span>Status</span>
            <span style={{ textAlign: 'right' }}>Valor</span>
            <span>Ações</span>
          </div>
        )}

        {carregando ? (
          <div style={{ padding: 40, textAlign: 'center', color: cores.muted }}>Carregando...</div>
        ) : paginados.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: cores.muted }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>📭</div>
            {busca || filtroStatus || filtroCategoria ? 'Nenhum lançamento com esses filtros.' : `Nenhum lançamento em ${titulo}.`}
          </div>
        ) : paginados.map((l, i) => {
          const sr = statusReal(l);
          const badge = STATUS_MAP[sr] || STATUS_MAP.pendente;
          const quitado = l.status === 'pago' || l.status === 'recebido';
          const isMob = window.innerWidth < 700;
          return (
            <div key={l.id} style={{ padding: '12px 16px', borderBottom: i < paginados.length - 1 ? `1px solid ${cores.border}` : 'none', fontSize: 13 }}>
              {isMob ? (
                /* ── MOBILE: card por linha ── */
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                    <div style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
                      <div style={{ fontWeight: 600, color: cores.navy, marginBottom: 2 }}>{l.descricao}</div>
                      {l.categoria && <div style={{ fontSize: 11, color: cores.muted }}>{l.categoria}</div>}
                    </div>
                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                      <div style={{ fontWeight: 800, fontSize: 15, color: corTitulo }}>{fmt(l.valor)}</div>
                      <div style={{ fontSize: 11, color: sr === 'vencido' ? cores.red : cores.muted, marginTop: 2 }}>
                        {l.data_vencimento ? new Date(l.data_vencimento.substring(0,10) + 'T12:00:00').toLocaleDateString('pt-BR') : '—'}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ background: badge.bg, color: badge.color, padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{badge.label}</span>
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                      {!quitado && (
                        <button onClick={() => alterarStatus(l.id, STATUS_BTN)}
                          style={{ padding: '5px 10px', background: '#d1f5e0', color: '#155724', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>
                          ✅ Baixa
                        </button>
                      )}
                      <button onClick={() => abrirEditar(l)}
                        style={{ padding: '5px 10px', background: '#eef2ff', color: '#2563eb', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>✏️</button>
                      <button onClick={() => excluir(l.id)}
                        style={{ padding: '5px 10px', background: '#fde8e8', color: '#e74c3c', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>🗑️</button>
                    </div>
                  </div>
                </div>
              ) : (
                /* ── DESKTOP: grid normal ── */
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 140px 110px 120px 110px', gap: 8, alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 600, color: cores.navy, marginBottom: 2 }}>{l.descricao}</div>
                    {l.categoria && <div style={{ fontSize: 11, color: cores.muted }}>{l.categoria}</div>}
                    {l.observacao && <div style={{ fontSize: 11, color: cores.muted, marginTop: 2 }}>{l.observacao}</div>}
                  </div>
                  <span style={{ color: sr === 'vencido' ? cores.red : cores.muted, fontWeight: sr === 'vencido' ? 700 : 400 }}>
                    {l.data_vencimento ? new Date(l.data_vencimento.substring(0,10) + 'T12:00:00').toLocaleDateString('pt-BR') : '—'}
                  </span>
                  <span>
                    <span style={{ background: badge.bg, color: badge.color, padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{badge.label}</span>
                  </span>
                  <span style={{ fontWeight: 700, color: corTitulo, textAlign: 'right' }}>{fmt(l.valor)}</span>
                  <div style={{ display: 'flex', gap: 6 }}>
                    {!quitado && (
                      <button onClick={() => alterarStatus(l.id, STATUS_BTN)}
                        style={{ padding: '4px 8px', background: '#d1f5e0', color: '#155724', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>
                        ✅
                      </button>
                    )}
                    <button onClick={() => abrirEditar(l)}
                      style={{ padding: '4px 8px', background: '#eef2ff', color: '#2563eb', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 11 }}>✏️</button>
                    <button onClick={() => excluir(l.id)}
                      style={{ padding: '4px 8px', background: '#fde8e8', color: '#e74c3c', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 11 }}>🗑️</button>
                  </div>
                </div>
              )}
            </div>
          );
        })}

        {/* Paginação */}
        {totalPags > 1 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderTop: `1px solid ${cores.border}`, fontSize: 13, color: cores.muted }}>
            <span>Mostrando {(pagina - 1) * POR_PAGINA + 1}–{Math.min(pagina * POR_PAGINA, filtrados.length)} de {filtrados.length}</span>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => setPagina(1)} disabled={pagina===1} style={{ ...btnGhost, padding:'6px 10px', fontSize:12, opacity: pagina===1?0.4:1 }}>Primeiro</button>
              <button onClick={() => setPagina(p=>Math.max(1,p-1))} disabled={pagina===1} style={{ ...btnGhost, padding:'6px 10px', fontSize:12, opacity: pagina===1?0.4:1 }}>Anterior</button>
              <span style={{ padding:'6px 10px', fontWeight:700, color: cores.navy }}>Pág {pagina}/{totalPags}</span>
              <button onClick={() => setPagina(p=>Math.min(totalPags,p+1))} disabled={pagina===totalPags} style={{ ...btnGhost, padding:'6px 10px', fontSize:12, opacity: pagina===totalPags?0.4:1 }}>Próxima</button>
              <button onClick={() => setPagina(totalPags)} disabled={pagina===totalPags} style={{ ...btnGhost, padding:'6px 10px', fontSize:12, opacity: pagina===totalPags?0.4:1 }}>Último</button>
            </div>
          </div>
        )}
      </Card>

      {/* Modal novo/editar */}
      {showModal && (
        <div onClick={e => e.target === e.currentTarget && setShowModal(false)}
          style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'white', borderRadius:16, padding:28, width:'100%', maxWidth:480, boxShadow:'0 24px 64px rgba(0,0,0,0.2)', maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ fontWeight:800, fontSize:17, marginBottom:20, color:'#1a2233' }}>
              {editando ? '✏️ Editar' : '➕ Nova'} {titulo}
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>Descrição *</label>
              <input value={form.descricao} onChange={e => setForm(p => ({...p, descricao: e.target.value}))}
                placeholder={tipo === 'pagar' ? 'Ex: Aluguel, Fornecedor...' : 'Ex: Venda de serviço...'} style={inputStyle} />
            </div>

            {/* Condição de pagamento — só na criação; editar continua sendo de 1 lançamento só */}
            {!editando && (
              <div style={{ display:'grid', gridTemplateColumns: form.condicao === 'parcelado' ? '1fr 1fr' : '1fr', gap:10, marginBottom:12 }}>
                <div>
                  <label style={labelStyle}>Condição</label>
                  <select value={form.condicao} onChange={e => setForm(p => ({...p, condicao: e.target.value}))} style={inputStyle}>
                    <option value="a_vista">À Vista</option>
                    <option value="parcelado">Parcelado</option>
                  </select>
                </div>
                {form.condicao === 'parcelado' && (
                  <div>
                    <label style={labelStyle}>Nº de Parcelas</label>
                    <select value={form.parcelas} onChange={e => setForm(p => ({...p, parcelas: e.target.value}))} style={inputStyle}>
                      {Array.from({ length: 11 }, (_, i) => i + 2).map(n => (
                        <option key={n} value={n}>{n}x</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            )}

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:12 }}>
              <div>
                <label style={labelStyle}>Valor (R$) *{form.condicao === 'parcelado' && !editando ? ' — total' : ''}</label>
                <input type="number" step="0.01" value={form.valor} onChange={e => setForm(p => ({...p, valor: e.target.value}))} placeholder="0,00" style={inputStyle} />
                {form.condicao === 'parcelado' && !editando && form.valor && parseInt(form.parcelas) > 0 && (
                  <div style={{ fontSize: 11, color: cores.muted, marginTop: 4 }}>
                    {form.parcelas}x de {(parseFloat(form.valor) / parseInt(form.parcelas)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </div>
                )}
              </div>
              <div>
                <label style={labelStyle}>Vencimento *{form.condicao === 'parcelado' && !editando ? ' — 1ª parcela' : ''}</label>
                <input type="date" value={form.data_vencimento} onChange={e => setForm(p => ({...p, data_vencimento: e.target.value}))} style={inputStyle} />
              </div>
            </div>
            {form.condicao === 'parcelado' && !editando && (
              <div style={{ fontSize: 11, color: cores.muted, marginTop: -8, marginBottom: 12 }}>
                Serão criados {form.parcelas} lançamentos, um por mês a partir do vencimento acima (mesmo dia do mês seguinte).
              </div>
            )}

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:12 }}>
              <div>
                <label style={labelStyle}>Categoria</label>
                <select value={form.categoria} onChange={e => setForm(p => ({...p, categoria: e.target.value}))} style={inputStyle}>
                  <option value="">— Selecionar —</option>
                  {categorias.map(c => <option key={c.id} value={c.nome}>{c.nome}</option>)}
                  <option value="__outro">Outra (digitar)</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Status</label>
                <select value={form.status} onChange={e => setForm(p => ({...p, status: e.target.value}))} style={inputStyle}>
                  <option value="pendente">{tipo === 'pagar' ? 'Pendente' : 'A Receber'}</option>
                  <option value={STATUS_BTN}>{tipo === 'pagar' ? 'Pago' : 'Recebido'}</option>
                </select>
              </div>
            </div>

            {form.categoria === '__outro' && (
              <div style={{ marginBottom: 12 }}>
                <label style={labelStyle}>Categoria (texto livre)</label>
                <input placeholder="Ex: Outro custo" onBlur={e => setForm(p => ({...p, categoria: e.target.value}))} style={inputStyle} />
              </div>
            )}

            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Observação (opcional)</label>
              <input value={form.observacao} onChange={e => setForm(p => ({...p, observacao: e.target.value}))}
                placeholder="Notas internas..." style={inputStyle} />
            </div>

            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setShowModal(false)} style={{ ...btnGhost, flex:1 }}>Cancelar</button>
              {editando && (
                <button onClick={() => excluir(editando)} style={{ padding:'9px 14px', background:cores.red, color:'white', border:'none', borderRadius:8, fontWeight:700, fontSize:14, cursor:'pointer' }}>🗑️</button>
              )}
              <button onClick={salvar} disabled={salvando} style={{ ...btnPrimary, flex:2 }}>
                {salvando
                  ? 'Salvando...'
                  : editando
                    ? 'Salvar Alterações'
                    : form.condicao === 'parcelado'
                      ? `Criar ${form.parcelas} Lançamentos`
                      : 'Criar Lançamento'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


// ── ABA BOLETOS ASAAS ─────────────────────────────────────────────────────────
function BoletoStatusBadge({ status }) {
  const map = {
    PENDING:    { label: 'Pendente',    bg: '#fef9c3', color: '#854d0e' },
    RECEIVED:   { label: 'Recebido',   bg: '#dcfce7', color: '#166534' },
    CONFIRMED:  { label: 'Confirmado', bg: '#d1fae5', color: '#065f46' },
    OVERDUE:    { label: 'Vencido',    bg: '#fee2e2', color: '#991b1b' },
    REFUNDED:   { label: 'Estornado',  bg: '#ede9fe', color: '#5b21b6' },
    CANCELED:   { label: 'Cancelado',  bg: '#f1f5f9', color: '#64748b' },
  };
  const s = map[status] || { label: status || '—', bg: '#f1f5f9', color: '#64748b' };
  return (
    <span style={{
      padding: '3px 10px', borderRadius: 20,
      background: s.bg, color: s.color,
      fontWeight: 700, fontSize: 12, whiteSpace: 'nowrap',
    }}>
      {s.label}
    </span>
  );
}

function AbaBoletos({ toast }) {
  const [boletos, setBoletos]               = useState([]);
  const [carregando, setCarregando]         = useState(false);
  const [erro, setErro]                     = useState('');
  const [filtroStatus, setFiltroStatus]     = useState('');
  const [filtroInicio, setFiltroInicio]     = useState('');
  const [filtroFim, setFiltroFim]           = useState('');
  const [totalCount, setTotalCount]         = useState(0);
  const [offset, setOffset]                 = useState(0);
  const [jaCarregou, setJaCarregou]         = useState(false);
  const LIMIT = 20;

  const buscar = useCallback(async (novoOffset = 0) => {
    setCarregando(true);
    setErro('');
    try {
      const params = new URLSearchParams({ offset: novoOffset, limit: LIMIT });
      if (filtroStatus)  params.append('status', filtroStatus);
      if (filtroInicio)  params.append('dataVencimentoInicio', filtroInicio);
      if (filtroFim)     params.append('dataVencimentoFim', filtroFim);

      const res = await api.get(`/financeiro/boletos?${params.toString()}`);
      setBoletos(res.data.data || []);
      setTotalCount(res.data.totalCount || 0);
      setOffset(novoOffset);
      setJaCarregou(true);
    } catch (e) {
      const msg = e?.response?.data?.erro || 'Erro ao carregar boletos.';
      setErro(msg);
      setBoletos([]);
      setJaCarregou(true);
    } finally {
      setCarregando(false);
    }
  }, [filtroStatus, filtroInicio, filtroFim]);

  const totalPags  = Math.ceil(totalCount / LIMIT);
  const paginaAtual = Math.floor(offset / LIMIT) + 1;

  const isMob = typeof window !== 'undefined' && window.innerWidth < 700;

  return (
    <div>
      {/* Painel de filtros */}
      <Card>
        <div style={{ fontWeight: 700, fontSize: 13, color: '#1a2233', marginBottom: 12 }}>Filtrar boletos:</div>
        <div style={{ display: 'grid', gridTemplateColumns: isMob ? '1fr' : '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>Status</label>
            <select value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)} style={{ ...inputStyle }}>
              <option value="">Todos</option>
              <option value="PENDING">Pendente</option>
              <option value="RECEIVED">Recebido</option>
              <option value="CONFIRMED">Confirmado</option>
              <option value="OVERDUE">Vencido</option>
              <option value="REFUNDED">Estornado</option>
              <option value="CANCELED">Cancelado</option>
            </select>
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>Vencimento de</label>
            <input type="date" value={filtroInicio} onChange={e => setFiltroInicio(e.target.value)} style={{ ...inputStyle }} />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>Vencimento até</label>
            <input type="date" value={filtroFim} onChange={e => setFiltroFim(e.target.value)} style={{ ...inputStyle }} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => buscar(0)} style={{ ...btnPrimary }}>
            🔍 Buscar
          </button>
          <button onClick={() => {
            setFiltroStatus('');
            setFiltroInicio('');
            setFiltroFim('');
            setBoletos([]);
            setTotalCount(0);
            setOffset(0);
            setJaCarregou(false);
            setErro('');
          }} style={{ ...btnGhost }}>
            ✕ Limpar
          </button>
        </div>
      </Card>

      {/* Aviso inicial */}
      {!jaCarregou && !carregando && !erro && (
        <Card>
          <div style={{ textAlign: 'center', padding: '24px 0', color: cores.muted }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>🏦</div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>Clique em <strong>Buscar</strong> para carregar os boletos do ASAAS.</div>
            <div style={{ fontSize: 12, marginTop: 6 }}>Use os filtros acima para refinar os resultados.</div>
          </div>
        </Card>
      )}

      {/* Loading */}
      {carregando && (
        <Card>
          <div style={{ textAlign: 'center', padding: '32px 0', color: cores.muted }}>
            Carregando boletos...
          </div>
        </Card>
      )}

      {/* Erro */}
      {!carregando && erro && (
        <div style={{
          background: '#fef2f2', border: '1px solid #fca5a5',
          borderRadius: 12, padding: '16px 20px',
          color: '#991b1b', marginBottom: 16,
        }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>⚠️ Não foi possível carregar os boletos</div>
          <div style={{ fontSize: 13 }}>{erro}</div>
          {erro.includes('não configurada') && (
            <div style={{ marginTop: 8, fontSize: 13 }}>
              Acesse <strong>Configurações → Integrações</strong> para cadastrar a API Key do ASAAS.
            </div>
          )}
        </div>
      )}

      {/* Resultado */}
      {!carregando && !erro && jaCarregou && (
        <>
          {/* KPIs rápidos */}
          <div style={{ display: 'grid', gridTemplateColumns: isMob ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: 10, marginBottom: 16 }}>
            {[
              { label: 'Total encontrado',  val: totalCount, cor: cores.navy },
              { label: 'Pendentes',  val: boletos.filter(b => b.status === 'PENDING').length,  cor: '#854d0e' },
              { label: 'Recebidos',  val: boletos.filter(b => ['RECEIVED','CONFIRMED'].includes(b.status)).length, cor: cores.green },
              { label: 'Vencidos',   val: boletos.filter(b => b.status === 'OVERDUE').length,  cor: cores.red },
            ].map(({ label, val, cor }) => (
              <div key={label} style={{ background: 'white', borderRadius: 12, padding: '12px 16px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', borderLeft: `4px solid ${cor}` }}>
                <div style={{ fontSize: 10, color: cores.muted, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: cor }}>{val}</div>
              </div>
            ))}
          </div>

          {/* Tabela */}
          {boletos.length === 0 ? (
            <Card>
              <div style={{ textAlign: 'center', padding: '32px 0', color: cores.muted }}>
                <div style={{ fontSize: 36, marginBottom: 8 }}>📭</div>
                Nenhum boleto encontrado com esses filtros.
              </div>
            </Card>
          ) : (
            <Card style={{ padding: 0, overflow: 'hidden' }}>
              {/* Cabeçalho — só desktop */}
              {!isMob && (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 180px 100px 110px 110px 130px',
                  gap: 8, padding: '10px 16px',
                  background: '#f8fafc', borderBottom: `1px solid ${cores.border}`,
                  fontSize: 11, fontWeight: 700, color: cores.muted, textTransform: 'uppercase',
                }}>
                  <span>Cliente</span>
                  <span>Descrição</span>
                  <span>Vencimento</span>
                  <span>Status</span>
                  <span style={{ textAlign: 'right' }}>Valor</span>
                  <span style={{ textAlign: 'center' }}>Ações</span>
                </div>
              )}

              {boletos.map((b, i) => (
                <div key={b.id} style={{
                  padding: '12px 16px',
                  borderBottom: i < boletos.length - 1 ? `1px solid ${cores.border}` : 'none',
                  fontSize: 13,
                }}>
                  {isMob ? (
                    /* MOBILE */
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                        <div style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
                          <div style={{ fontWeight: 600, color: cores.navy }}>{b.customerName || '—'}</div>
                          {b.description && <div style={{ fontSize: 11, color: cores.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.description}</div>}
                        </div>
                        <div style={{ textAlign: 'right', flexShrink: 0 }}>
                          <div style={{ fontWeight: 800, fontSize: 15, color: b.status === 'OVERDUE' ? cores.red : cores.navy }}>
                            {Number(b.value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                          </div>
                          <div style={{ fontSize: 11, color: cores.muted, marginTop: 2 }}>
                            {b.dueDate ? new Date(b.dueDate + 'T00:00:00').toLocaleDateString('pt-BR') : '—'}
                          </div>
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <BoletoStatusBadge status={b.status} />
                        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                          {b.bankSlipUrl && (
                            <a href={b.bankSlipUrl} target="_blank" rel="noopener noreferrer"
                              style={{ padding: '4px 10px', background: cores.navy, color: '#fff', borderRadius: 6, fontSize: 11, fontWeight: 700, textDecoration: 'none' }}>
                              📄 Boleto
                            </a>
                          )}
                          {b.invoiceUrl && (
                            <a href={b.invoiceUrl} target="_blank" rel="noopener noreferrer"
                              style={{ padding: '4px 10px', background: '#f0f3f7', color: cores.muted, borderRadius: 6, fontSize: 11, fontWeight: 600, textDecoration: 'none', border: `1px solid ${cores.border}` }}>
                              🔗
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    /* DESKTOP */
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 180px 100px 110px 110px 130px',
                      gap: 8, alignItems: 'center',
                    }}>
                      <div>
                        <div style={{ fontWeight: 600, color: cores.navy, marginBottom: 2 }}>{b.customerName || '—'}</div>
                        {b.customerEmail && <div style={{ fontSize: 11, color: cores.muted }}>{b.customerEmail}</div>}
                        {b.externalReference && <div style={{ fontSize: 11, color: cores.muted }}>Ref: {b.externalReference}</div>}
                      </div>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: cores.muted, fontSize: 12 }}>
                        {b.description || '—'}
                      </div>
                      <span style={{ color: b.status === 'OVERDUE' ? cores.red : cores.muted, fontWeight: b.status === 'OVERDUE' ? 700 : 400 }}>
                        {b.dueDate ? new Date(b.dueDate + 'T00:00:00').toLocaleDateString('pt-BR') : '—'}
                      </span>
                      <span><BoletoStatusBadge status={b.status} /></span>
                      <span style={{ fontWeight: 700, textAlign: 'right', color: b.status === 'OVERDUE' ? cores.red : cores.navy }}>
                        {Number(b.value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </span>
                      <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                        {b.bankSlipUrl && (
                          <a href={b.bankSlipUrl} target="_blank" rel="noopener noreferrer"
                            style={{ padding: '4px 10px', background: cores.navy, color: '#fff', borderRadius: 6, fontSize: 11, fontWeight: 700, textDecoration: 'none', whiteSpace: 'nowrap' }}>
                            📄 Boleto
                          </a>
                        )}
                        {b.invoiceUrl && (
                          <a href={b.invoiceUrl} target="_blank" rel="noopener noreferrer" title="Ver fatura ASAAS"
                            style={{ padding: '4px 10px', background: '#f0f3f7', color: cores.muted, borderRadius: 6, fontSize: 11, fontWeight: 600, textDecoration: 'none', border: `1px solid ${cores.border}`, whiteSpace: 'nowrap' }}>
                            🔗 Fatura
                          </a>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}

              {/* Paginação */}
              {totalPags > 1 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderTop: `1px solid ${cores.border}`, fontSize: 13, color: cores.muted }}>
                  <span>Página {paginaAtual} de {totalPags} · {totalCount} boleto(s)</span>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => buscar(0)} disabled={offset === 0}
                      style={{ ...btnGhost, padding: '6px 10px', fontSize: 12, opacity: offset === 0 ? 0.4 : 1 }}>Primeiro</button>
                    <button onClick={() => buscar(offset - LIMIT)} disabled={offset === 0}
                      style={{ ...btnGhost, padding: '6px 10px', fontSize: 12, opacity: offset === 0 ? 0.4 : 1 }}>Anterior</button>
                    <span style={{ padding: '6px 10px', fontWeight: 700, color: cores.navy }}>Pág {paginaAtual}/{totalPags}</span>
                    <button onClick={() => buscar(offset + LIMIT)} disabled={offset + LIMIT >= totalCount}
                      style={{ ...btnGhost, padding: '6px 10px', fontSize: 12, opacity: offset + LIMIT >= totalCount ? 0.4 : 1 }}>Próxima</button>
                    <button onClick={() => buscar((totalPags - 1) * LIMIT)} disabled={offset + LIMIT >= totalCount}
                      style={{ ...btnGhost, padding: '6px 10px', fontSize: 12, opacity: offset + LIMIT >= totalCount ? 0.4 : 1 }}>Último</button>
                  </div>
                </div>
              )}
            </Card>
          )}
        </>
      )}
    </div>
  );
}

export default function Financeiro({ toast }) {
  const [aba, setAba] = useState('pagar');

  const abas = [
    { key: 'pagar',     label: '💸 Contas a Pagar' },
    { key: 'receber',   label: '💰 Contas a Receber' },
    { key: 'notas',     label: '🧾 NFs' },
    { key: 'boletos',   label: '🏦 Boletos' },
    { key: 'reembolso', label: '🔄 Reembolso' },
    { key: 'salarios',  label: '👥 Salários'  },
  ];

  const isMobileFinanceiro = typeof window !== 'undefined' && window.innerWidth < 700;

  return (
    <div style={{ padding: '0 0 32px' }}>
      {/* Header */}
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ margin: '0 0 4px', fontSize: 20, fontWeight: 800, color: '#1a2233' }}>Financeiro</h2>
        <p style={{ margin: 0, fontSize: 13, color: cores.muted }}>Gestão de reembolsos e salários</p>
      </div>

      {/* Abas — mobile: grid com ícone; desktop: flex com texto */}
      {isMobileFinanceiro ? (
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(${abas.length}, 1fr)`, gap: 6, marginBottom: 16 }}>
          {abas.map(a => {
            const icone = a.label.match(/^\S+/)?.[0] || a.label[0];
            const texto = a.label.replace(/^\S+\s*/, '');
            return (
              <button key={a.key} onClick={() => setAba(a.key)} style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                padding: '8px 4px', borderRadius: 10, border: 'none', cursor: 'pointer',
                fontWeight: 600, fontSize: 11, gap: 3, lineHeight: 1.2,
                background: aba === a.key ? cores.orange : '#f0f3f7',
                color: aba === a.key ? 'white' : cores.muted,
              }}>
                <span style={{ fontSize: 18 }}>{icone}</span>
                <span style={{ textAlign: 'center', wordBreak: 'break-word' }}>{texto}</span>
              </button>
            );
          })}
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
          {abas.map(a => (
            <button key={a.key} onClick={() => setAba(a.key)} style={{
              padding: '9px 20px', borderRadius: 20, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: 13,
              background: aba === a.key ? cores.orange : '#f0f3f7',
              color: aba === a.key ? 'white' : cores.muted,
            }}>
              {a.label}
            </button>
          ))}
        </div>
      )}

      {aba === 'reembolso' && <AbaReembolso toast={toast} />}
      {aba === 'salarios'  && <AbaSalarios  toast={toast} />}
      {aba === 'pagar'     && <AbaContasFinanceiro tipo="pagar"   toast={toast} />}
      {aba === 'receber'   && <AbaContasFinanceiro tipo="receber" toast={toast} />}
      {aba === 'notas'     && <AbaNotasFiscais toast={toast} />}
      {aba === 'boletos'   && <AbaBoletos toast={toast} />}
    </div>
  );
}
